import React, { useState, useEffect, useCallback } from "react";
import "./../../App.css";
import "./Transactions.css";
import { Tab, Tabs, TabList, TabPanel } from "react-tabs";
import {
  CreateButton,
  CreateSearchBarWithPlaceHolder,
} from "./../CommonObjects";
import axios from "axios";
import { token, domain } from "./../Security";
import { CreateTableForEmployeeSelect } from "./../ManageTable";
import loadingSpinner from "./../../assets/loading.gif";
import { useTable, useSortBy } from "react-table";
import { globalTimeFormat } from "./../Security";
// icons
import ModeEditIcon from "@mui/icons-material/ModeEdit";
import DeleteForeverIcon from "@mui/icons-material/DeleteForever";
import NavigateNextIcon from "@mui/icons-material/NavigateNext";
import NavigateBeforeIcon from "@mui/icons-material/NavigateBefore";
import SearchIcon from "@mui/icons-material/Search";
import CloseIcon from "@mui/icons-material/Close";
import ErrorIcon from "@mui/icons-material/Error";
import CheckCircleIcon from "@mui/icons-material/CheckCircle";
import RemoveRedEyeIcon from "@mui/icons-material/RemoveRedEye";
import AddIcon from '@mui/icons-material/Add';
import EditIcon from '@mui/icons-material/Edit';
import NotInterestedIcon from '@mui/icons-material/NotInterested';
import ImageIcon from '@mui/icons-material/Image';

function OffsetRequest({ user, userAccess, isHideSideMenu }) {
  const [loadingRequest, setLoadingRequest] = useState(false);
  const [employee, setEmployee] = useState(
    user.employeePersonalInformationFullName
  );
  const [employeeId, setEmployeeId] = useState(
    user.employeePersonalInformationId
  );
  const [type, setType] = useState("Overtime");
  const [currentType, setCurrentType] = useState("Overtime");

  useEffect(() => {
    if(type !== currentType){
      setCurrentType(type);
      setDate("");
      setHours(0);
      setReferenceDate([]);
      setReference([]);
      setDateFrom("");
      setDateTo("");
      setDays(0);
    }
  }, [currentType, type])

  //overtime
  const [date, setDate] = useState("");
  const [hours, setHours] = useState(0);
  const [referenceDate, setReferenceDate] = useState([]);
  //leave
  const [reference, setReference] = useState([]);
  const [dateFrom, setDateFrom] = useState("");
  const [dateTo, setDateTo] = useState("");
  const [days, setDays] = useState(0);
  const [reason, setReason] = useState("");
  const [files, setFiles] = useState([]);
    const [gpsCam, setGPSCam] = useState([]);
  //overtime
  const [referenceHolidayDate, setReferenceHolidayDate] = useState([]);
  const [holidayDate, setHolidayDate] = useState("");
  const [holidayDays, setHolidayDays] = useState(0);

  const [offsetType, setOffsetType] = useState(""); // Default is wholeday

  const resetLocalVariables = () => {
    setDate("");
    setHours(0);
    setReferenceDate([]);
    setReference([]);
    setDateFrom("");
    setDateTo("");
    setDays(0);
    setReason("");
    setFiles([]);
    setReferenceHolidayDate([]);
    setHolidayDate("");
    setHolidayDays(0);
    setOffsetType("wholeday")
  };

  const [showVieHistoryForm, setShowVieHistoryForm] = useState(false);
  const [showEmployeeForm, setShowEmployeeForm] = useState(false);
  //Request Messages -start
  const [showRequestMessage, setShowRequestMessage] = useState(false);
  const [requestMessage, setRequestMessage] = useState("");
  const [isSuccess, setIsSuccess] = useState("");
  useEffect(() => {
    if (showRequestMessage) {
      const timeoutId = setTimeout(() => {
        setShowRequestMessage(false);
      }, 5000);

      return () => clearTimeout(timeoutId);
    }
  }, [showRequestMessage]);
  function GenerateMessage({ form, message, isSuccess }) {
    return (
      <>
        <div
          className={`modal-overlay toggleMessage-overlay ${
            form ? "open" : ""
          }`}
        >
          {form && (
            <div
              className="modal toggleMessage"
              style={{ backgroundColor: isSuccess ? "#E0FFDC" : "#ffd0c5" }}
            >
              <div className="column">
                {isSuccess ? (
                  <div
                    className="request_title row"
                    style={{
                      fontWeight: "bold",
                      color: "green",
                      alignItems: "center",
                    }}
                  >
                    <CheckCircleIcon />
                    <span>{"SUCCESS MESSAGE"}</span>
                  </div>
                ) : (
                  <div
                    className="request_title row"
                    style={{
                      fontWeight: "bold",
                      color: "#DD5746",
                      alignItems: "center",
                    }}
                  >
                    <ErrorIcon />
                    <span>{"ERROR MESSAGE"}</span>
                  </div>
                )}
                <span
                  style={{
                    textAlign: "center",
                    padding: "10px 0",
                    color: isSuccess ? "green" : "#DD5746",
                  }}
                >
                  {message}
                </span>
              </div>
            </div>
          )}
        </div>
      </>
    );
  }
  //Request Messages -end

  // console.log({referenceHolidayDate})

  const handleSubmit = async (event) => {
    event.preventDefault();

    if (type === "Overtime") {
      if (!employee || referenceDate.length <= 0 || !date || !hours) {
        alert("Required to fill up all data");
        return; // Exit early if fields are empty
      }

      const totalHours = referenceDate.reduce((sum, item) => sum + (item.hours || 0), 0);

      if (hours > totalHours) {
        alert("Not enough offset credit.");
        return; // Exit early if fields are empty
      }
    } else if (type === "Leave") {
      if (!employee || !reference || !days || !dateFrom || !dateTo) {
        alert("Required to fill up all data");
        return; // Exit early if fields are empty
      }

      const totalDays = reference.reduce((sum, item) => sum + (item?.leaveData?.days || 0), 0);

      if (days > totalDays) {
        alert("Not enough offset credit.");
        return; // Exit early if fields are empty
      }
    }
    if (type === "Holiday") {
      if (!employee || referenceHolidayDate.length <= 0 || !holidayDays) {
        alert("Required to fill up all data");
        return; // Exit early if fields are empty
      }

      const totalHolidayDays = referenceHolidayDate.reduce((sum, item) => sum + (item.days || 0), 0);

      if (holidayDays > totalHolidayDays) {
        alert("Not enough offset credit.");
        return; // Exit early if fields are empty
      }
    }

    const getFormattedDate = () => {
      const today = new Date();
      const year = today.getFullYear();
      const month = String(today.getMonth() + 1).padStart(2, "0");
      const day = String(today.getDate()).padStart(2, "0");
      const formattedDate = `${year}-${month}-${day}T00:00`;
      return formattedDate;
    };

    const toBase64 = (file) =>
      new Promise((resolve, reject) => {
        const reader = new FileReader();
        reader.readAsDataURL(file);
        reader.onload = () => resolve(reader.result);
        reader.onerror = (error) => reject(error);
      });

    let base64String = "";
    let photoToBeSave = "";

    if (files?.length > 0) {
      base64String = await toBase64(files[0]);
      photoToBeSave = base64String.split(",")[1];
    }

    const uploadImage = files ? photoToBeSave : null;

    let _reference = null;

    if(type === "Overtime"){
      _reference = referenceDate.map((item) =>({
        referenceDate: item?.date ? item?.date : null,
        hours: item?.hours ? item?.hours : null,
      }))
    } else if(type === "Leave"){
      _reference = reference.map((item) =>({
        referenceId: item?.id ? item?.id : null,
        days: item?.leaveData?.days ? item?.leaveData?.days : null,
      }))
    }
    else if(type === "Holiday"){
      _reference = referenceHolidayDate.map((item) =>({
        referenceHolidayDate: item?.date ? item?.date : null,
        holidayDays: item?.days ? item?.days : null,
      }))
    }

    const data = {
      employeePersonalInformationId: employeeId,
      approverId: null,
      requestTypeId: 5, // 5 is Offset Request
      reason: reason,
      reasonForRejection: null,
      status: "Sent",
      dateRequested: getFormattedDate(),
      dateCompleted: getFormattedDate(),
      content: uploadImage,
      type: type,
      offsetType: offsetType,
      date: date ? date : null,
      totalHours: hours ? hours : null,
      dateFrom: dateFrom ? dateFrom : null,
      dateTo: dateTo ? dateTo : null,
      totalDays: days ? days : null,
      holidayDate: holidayDate ? holidayDate : null,
      holidayDays: holidayDays ? holidayDays : null,
      references: _reference
    };

    console.log("Final bulkData:", JSON.stringify(data, null, 2));

    const url = `${domain}/api/OffsetRequest`;

    try {
      setLoadingRequest(true);
      const response = await axios.post(url, data, {
        headers: {
          Authorization: `Bearer ${token}`,
          "Content-Type": "application/json",
        },
      });
      const allowSMS = false;
      if(allowSMS){
          await sendSms(response.data);
      }
      await createApproval(response.data);
      await fetchData();

      setShowRequestMessage(true);
      setIsSuccess(true);
      console.log("Data added successfully");

      // Reload table data and reset form fields
      resetLocalVariables();
    } catch (error) {
      setShowRequestMessage(true);
      setIsSuccess(false);
      console.error("Error:", error);
      const errorMessage = JSON.parse(
        error.response.request.responseText
      ).message;
      setRequestMessage(errorMessage);
    } finally {
      setLoadingRequest(false);
    }
  };
  const handleSubmitNew = async (event) => {
    event.preventDefault();

    if (type === "Overtime") {
      if (!employee || referenceDate.length <= 0 || !date) {
        alert("Required to fill up all data");
        return; // Exit early if fields are empty
      }
    }

    const getFormattedDate = () => {
      const today = new Date();
      const year = today.getFullYear();
      const month = String(today.getMonth() + 1).padStart(2, "0");
      const day = String(today.getDate()).padStart(2, "0");
      const formattedDate = `${year}-${month}-${day}T00:00`;
      return formattedDate;
    };

    const toBase64 = (file) =>
      new Promise((resolve, reject) => {
        const reader = new FileReader();
        reader.readAsDataURL(file);
        reader.onload = () => resolve(reader.result);
        reader.onerror = (error) => reject(error);
      });

    let base64String = "";
    let photoToBeSave = "";

    if (files?.length > 0) {
      base64String = await toBase64(files[0]);
      photoToBeSave = base64String.split(",")[1];
    }

    const uploadImage = files ? photoToBeSave : null;

    let _reference = null;

    if(type === "Overtime"){
      _reference = referenceDate.map((item) =>({
        referenceDate: item?.date ? item?.date : null,
      }))
    }

    //GPS CAM
    let base64StringGPSCam = "";
    let photoToBeSaveGPSCam = "";

    if(gpsCam.length > 0){
        base64StringGPSCam = await toBase64(gpsCam[0]);
        photoToBeSaveGPSCam = base64StringGPSCam.split(',')[1];
    }

    const _gpsCam = gpsCam ? photoToBeSaveGPSCam : null;

    const data = {
      employeePersonalInformationId: employeeId,
      approverId: null,
      requestTypeId: 5, // 5 is Offset Request
      reason: reason,
      reasonForRejection: null,
      status: "Sent",
      dateRequested: getFormattedDate(),
      dateCompleted: getFormattedDate(),
      content: uploadImage,
      gpsCam: _gpsCam,
      type: type,
      offsetType: offsetType,
      referenceDate: referenceDate[0] != null ? referenceDate[0].date : null,
      date: date ? date : null,
      totalHours: hours ? hours : null,
      dateFrom: dateFrom ? dateFrom : null,
      dateTo: dateTo ? dateTo : null,
      totalDays: days ? days : null,
      holidayDate: holidayDate ? holidayDate : null,
      holidayDays: holidayDays ? holidayDays : null,
      references: _reference
    };

    console.log("Final bulkData:", JSON.stringify(data, null, 2));

    const url = `${domain}/api/OffsetRequest`;

    try {
      setLoadingRequest(true);
      const response = await axios.post(url, data, {
        headers: {
          Authorization: `Bearer ${token}`,
          "Content-Type": "application/json",
        },
      });
      const allowSMS = false;
      if(allowSMS){
          await sendSms(response.data);
      }
      await createApproval(response.data);
      await fetchData();

      setShowRequestMessage(true);
      setIsSuccess(true);
      console.log("Data added successfully");

      // Reload table data and reset form fields
      resetLocalVariables();
    } catch (error) {
      setShowRequestMessage(true);
      setIsSuccess(false);
      console.error("Error:", error);
      const errorMessage = JSON.parse(
        error.response.request.responseText
      ).message;
      setRequestMessage(errorMessage);
    } finally {
      setLoadingRequest(false);
    }
  };
  const createApproval = async (dataToAdd) => {
    const apiUrl = domain + "/api/Approval";

    const data = {
      requestId: dataToAdd.id,
      requestTypeId: dataToAdd.requestTypeId,
      primaryApproverId: null,
      primaryApproverUpdateDate: null,
      primaryApproverStatus: "Pending",
      secondaryApproverId: null,
      secondaryApproverUpdateDate: null,
      secondaryApproverStatus: "Pending",
      tertiaryApproverId: null,
      tertiaryApproverUpdateDate: null,
      tertiaryApproverStatus: "Pending",
    };

    try {
      await axios.post(apiUrl + `/${0}`, data, {
        headers: {
          Authorization: `Bearer ${token}`,
          "Content-Type": "application/json",
        },
      });
      console.log("create approval success");
    } catch (error) {
      console.error("Error:", error);
    }
  };
  const closeEmployeeForm = () => {
    setShowEmployeeForm(false);
  };

  const [errorState, setErrorState] = useState(false);

  const submit = (e) => {
    if (type === "Overtime") {
      if (!employee || !referenceDate || !date) {
        setErrorState(true);
        return; // Exit early if fields are empty
      }
    } else if (type === "Leave") {
      if (!employee || !reference || !days || !dateFrom || !dateTo) {
        setErrorState(true);
        return; // Exit early if fields are empty
      }
    }

    if(files.length === 0){
        setShowRequestMessage(true);
        setIsSuccess(false);
        setRequestMessage("Attached proof of approval is required.");

        return;
    }

    if(isNewFunc){
      handleSubmitNew(e);
    } else {
      handleSubmit(e);
    }

    setErrorState(false);
  };

  const openViewHistoryForm = () => {
    setShowVieHistoryForm(true);
  };
  const closeViewHistoryForm = () => {
    setShowVieHistoryForm(false);
  };

  //send sms
  const fetchDataApproverById = useCallback(async () => {
    const apiUrl = domain + "/api/ApproverHierarchy";

    try {
      const response = await axios.get(
        apiUrl + `/${user.employeePersonalInformationId}`,
        {
          headers: {
            Authorization: `Bearer ${token}`,
            "Content-Type": "application/json", // You can include other headers if needed
          },
        }
      );

      return response.data;
    } catch (error) {
      console.error("Error fetching data:", error);
      return [];
    }
  }, [user]);
  const fetchDataEmployeesById = useCallback(async (id) => {
    const apiUrl = domain + "/api/Employee";

    try {
      const response = await axios.get(apiUrl + `/${id}`, {
        headers: {
          Authorization: `Bearer ${token}`,
          "Content-Type": "application/json",
        },
      });

      return response.data;
    } catch (error) {
      console.error("Error fetching data:", error);
      return [];
    }
  }, []);
  const getApproverContact = async () => {
    const formatPhoneNumber = (number) => {
      // Remove all dashes
      const cleanedNumber = number.replace(/-/g, "");

      // Check if the number starts with '0' and remove it
      const formattedNumber = cleanedNumber.startsWith("0")
        ? "+63" + cleanedNumber.slice(1)
        : "+63" + cleanedNumber;

      return formattedNumber;
    };

    const myApprover = await fetchDataApproverById();
    // const employeesInfo = await fetchDataEmployeesById();
    let approverNumbers = [];

    if (myApprover.primaryApprover) {
      if (myApprover.primaryApprover.primaryApprover1Id) {
        const foundndInfo = await fetchDataEmployeesById(
          myApprover.primaryApprover.primaryApprover1Id
        );

        if (foundndInfo && foundndInfo.mobileNumber) {
          approverNumbers.push({
            phoneNumber: formatPhoneNumber(foundndInfo.mobileNumber),
            id: myApprover.primaryApprover.primaryApprover1Id,
            fullName: myApprover.primaryApprover.primaryApprover1FullName,
          });
        }
      }

      if (myApprover.primaryApprover.primaryApprover2Id) {
        const foundndInfo = await fetchDataEmployeesById(
          myApprover.primaryApprover.primaryApprover2Id
        );

        if (foundndInfo && foundndInfo.mobileNumber) {
          approverNumbers.push({
            phoneNumber: formatPhoneNumber(foundndInfo.mobileNumber),
            id: myApprover.primaryApprover.primaryApprover2Id,
            fullName: myApprover.primaryApprover.primaryApprover2FullName,
          });
        }
      }

      if (myApprover.primaryApprover.primaryApprover3Id) {
        const foundndInfo = await fetchDataEmployeesById(
          myApprover.primaryApprover.primaryApprover3Id
        );

        if (foundndInfo && foundndInfo.mobileNumber) {
          approverNumbers.push({
            phoneNumber: formatPhoneNumber(foundndInfo.mobileNumber),
            id: myApprover.primaryApprover.primaryApprover3Id,
            fullName: myApprover.primaryApprover.primaryApprover3FullName,
          });
        }
      }

      if (myApprover.primaryApprover.primaryApprover4Id) {
        const foundndInfo = await fetchDataEmployeesById(
          myApprover.primaryApprover.primaryApprover4Id
        );

        if (foundndInfo && foundndInfo.mobileNumber) {
          approverNumbers.push({
            phoneNumber: formatPhoneNumber(foundndInfo.mobileNumber),
            id: myApprover.primaryApprover.primaryApprover4Id,
            fullName: myApprover.primaryApprover.primaryApprover4FullName,
          });
        }
      }
    }

    if (myApprover.secondaryApprover) {
      if (myApprover.secondaryApprover.secondaryApprover1Id) {
        const foundndInfo = await fetchDataEmployeesById(
          myApprover.secondaryApprover.secondaryApprover1Id
        );

        if (foundndInfo && foundndInfo.mobileNumber) {
          approverNumbers.push({
            phoneNumber: formatPhoneNumber(foundndInfo.mobileNumber),
            id: myApprover.secondaryApprover.secondaryApprover1Id,
            fullName: myApprover.secondaryApprover.secondaryApprover1FullName,
          });
        }
      }

      if (myApprover.secondaryApprover.secondaryApprover2Id) {
        const foundndInfo = await fetchDataEmployeesById(
          myApprover.secondaryApprover.secondaryApprover2Id
        );

        if (foundndInfo && foundndInfo.mobileNumber) {
          approverNumbers.push({
            phoneNumber: formatPhoneNumber(foundndInfo.mobileNumber),
            id: myApprover.secondaryApprover.secondaryApprover2Id,
            fullName: myApprover.secondaryApprover.secondaryApprover2FullName,
          });
        }
      }

      if (myApprover.secondaryApprover.secondaryApprover3Id) {
        const foundndInfo = await fetchDataEmployeesById(
          myApprover.secondaryApprover.secondaryApprover3Id
        );

        if (foundndInfo && foundndInfo.mobileNumber) {
          approverNumbers.push({
            phoneNumber: formatPhoneNumber(foundndInfo.mobileNumber),
            id: myApprover.secondaryApprover.secondaryApprover3Id,
            fullName: myApprover.secondaryApprover.secondaryApprover3FullName,
          });
        }
      }

      if (myApprover.secondaryApprover.secondaryApprover4Id) {
        const foundndInfo = await fetchDataEmployeesById(
          myApprover.secondaryApprover.secondaryApprover4Id
        );

        if (foundndInfo && foundndInfo.mobileNumber) {
          approverNumbers.push({
            phoneNumber: formatPhoneNumber(foundndInfo.mobileNumber),
            id: myApprover.secondaryApprover.secondaryApprover4Id,
            fullName: myApprover.secondaryApprover.secondaryApprover4FullName,
          });
        }
      }
    }

    if (myApprover.tertiaryApprover) {
      if (myApprover.tertiaryApprover.tertiaryApprover1Id) {
        const foundndInfo = await fetchDataEmployeesById(
          myApprover.tertiaryApprover.tertiaryApprover1Id
        );

        if (foundndInfo && foundndInfo.mobileNumber) {
          approverNumbers.push({
            phoneNumber: formatPhoneNumber(foundndInfo.mobileNumber),
            id: myApprover.tertiaryApprover.tertiaryApprover1Id,
            fullName: myApprover.tertiaryApprover.tertiaryApprover1FullName,
          });
        }
      }

      if (myApprover.tertiaryApprover.tertiaryApprover2Id) {
        const foundndInfo = await fetchDataEmployeesById(
          myApprover.tertiaryApprover.tertiaryApprover2Id
        );

        if (foundndInfo && foundndInfo.mobileNumber) {
          approverNumbers.push({
            phoneNumber: formatPhoneNumber(foundndInfo.mobileNumber),
            id: myApprover.tertiaryApprover.tertiaryApprover2Id,
            fullName: myApprover.tertiaryApprover.tertiaryApprover2FullName,
          });
        }
      }

      if (myApprover.tertiaryApprover.tertiaryApprover3Id) {
        const foundndInfo = await fetchDataEmployeesById(
          myApprover.tertiaryApprover.tertiaryApprover3Id
        );

        if (foundndInfo && foundndInfo.mobileNumber) {
          approverNumbers.push({
            phoneNumber: formatPhoneNumber(foundndInfo.mobileNumber),
            id: myApprover.tertiaryApprover.tertiaryApprover3Id,
            fullName: myApprover.tertiaryApprover.tertiaryApprover3FullName,
          });
        }
      }

      if (myApprover.tertiaryApprover.tertiaryApprover4Id) {
        const foundndInfo = await fetchDataEmployeesById(
          myApprover.tertiaryApprover.tertiaryApprover4Id
        );

        if (foundndInfo && foundndInfo.mobileNumber) {
          approverNumbers.push({
            phoneNumber: formatPhoneNumber(foundndInfo.mobileNumber),
            id: myApprover.tertiaryApprover.tertiaryApprover4Id,
            fullName: myApprover.tertiaryApprover.tertiaryApprover4FullName,
          });
        }
      }
    }

    return approverNumbers;
  };
  const sendSms = async (data) => {
    const formattedNumber = data.referenceNumber.toString().padStart(6, "0");
    const contacts = await getApproverContact();

    if (contacts?.length <= 0) {
      return;
    }

    const composeMessage = `Hello,

${employee} filed an Offset Request. 

Please check reference number OS-${formattedNumber} in the portal.`;
    for (const contact of contacts) {
      const smsData = {
        requestTypeId: 5,
        date: new Date(),
        senderId: user.employeePersonalInformationId,
        senderFullName: user.employeePersonalInformationFullName,
        message: composeMessage,
        recipientId: contact.id,
        recipientFullName: contact.fullName,
        recipientMobileNumber: contact.phoneNumber, // phoneNumber
      };

      try {
        const response = await axios.post(
          "http://161.49.93.114:8081/api/Sms/send-sms",
          smsData
        ); // euro asia
        // const response = await axios.post('http://192.168.10.157:8082/api/Sms/send-sms', smsData); // my server
        console.log(
          response,
          `SMS request sent to ${smsData.recipientFullName} ${smsData.recipientMobileNumber}.`
        );
      } catch (error) {
        console.error(
          `Error sending SMS request to ${smsData.recipientFullName} ${smsData.recipientMobileNumber}:`,
          error
        );
        console.log(
          `Failed to send SMS request to ${smsData.recipientFullName} ${smsData.recipientMobileNumber}.`
        );
      }
    }
  };
  const sendSmsTrial = async () => {
    const smsData = {
      requestTypeId: 1,
      date: new Date(),
      senderId: 3151,
      senderFullName: "Calingasan, JV",
      message: "TEST",
      recipientId: 3078,
      recipientFullName: "santos, immanuel",
      recipientMobileNumber: "+639067985609", // phoneNumber
    };

    try {
      setLoadingRequest(true);
      // const response = await axios.post('http://161.49.93.114:8081/api/Sms/send-sms', smsData); // euro asia
      const response = await axios.post(
        "http://192.168.10.157:8082/api/Sms/send-sms",
        smsData
      ); // my server
      console.log(
        response,
        `SMS request sent to ${smsData.recipientFullName} ${smsData.recipientMobileNumber}.`
      );
    } catch (error) {
      console.error(
        `Error sending SMS request to ${smsData.recipientFullName} ${smsData.recipientMobileNumber}:`,
        error
      );
      console.log(
        `Failed to send SMS request to ${smsData.recipientFullName} ${smsData.recipientMobileNumber}.`
      );
    }

    setLoadingRequest(false);
  };

  let testSMS = false;
  var isNewFunc = true;

  const [offsetDate, setOffsetDate] = useState([]);
  const [overtimeData, setOvertimeData] = useState([]);
  const [leaveData, setLeaveData] = useState([]);
  const [holidayData, setHolidayData] = useState([]);

  const fetchDataOvertime = useCallback(async () => {
    const apiUrl = domain + `/api/OffsetOvertime/employee/${employeeId}`;

    try {
      const response = await axios.get(apiUrl, {
        headers: {
          Authorization: `Bearer ${token}`,
          "Content-Type": "application/json", // You can include other headers if needed
        },
      });
      return response.data;
    } catch (error) {
      console.error("Error fetching data:", error);
      return [];
    }
  }, [employeeId]);
  const fetchDataLeave = useCallback(async () => {
    const apiUrl = domain + `/api/OffsetLeave/employee/${employeeId}`;

    try {
      const response = await axios.get(apiUrl, {
        headers: {
          Authorization: `Bearer ${token}`,
          "Content-Type": "application/json", // You can include other headers if needed
        },
      });
      return response.data;
    } catch (error) {
      console.error("Error fetching data:", error);
      return [];
    }
  }, [employeeId]);

  const generateData = useCallback(async () => {
    const apiUrl = domain + `/api/OffsetRequest/generate-offset/employee/${employeeId}`;

    try {
      const response = await axios.post(apiUrl, {}, {
        headers: {
          Authorization: `Bearer ${token}`,
          "Content-Type": "application/json", // You can include other headers if needed
        },
      });

      console.log("response", response.data, apiUrl)
      return response.data
    } catch (error) {
      console.error("Error fetching data:", error);
      return null
    }
  }, [employeeId]);

  const generateNewData = useCallback(async () => {
    const apiUrl = domain + `/api/OffsetRequest/generate-offset-date/employee/${employeeId}/selection/${true}`;

    try {
      const response = await axios.post(apiUrl, {}, {
        headers: {
          Authorization: `Bearer ${token}`,
          "Content-Type": "application/json", // You can include other headers if needed
        },
      });

      const filtered = response.data.filter(i => {
        return (new Date(i.timeOut).getHours() >= 22 || new Date(i.timeOut).getHours() < 6)
      })

      console.log("response", filtered, apiUrl)
      return filtered
    } catch (error) {
      console.error("Error fetching data:", error);
      return null
    }
  }, [employeeId]);

  const fetchDataOld = useCallback(async () => {
    setLoadingRequest(true);

    await generateData();

    const _overtimeData = await fetchDataOvertime();
    const _leaveDate = await fetchDataLeave();

    setOvertimeData(_overtimeData);
    setLeaveData(_leaveDate);

    setLoadingRequest(false);
  }, [fetchDataOvertime, fetchDataLeave, generateData]);

  const fetchData = useCallback(async () => {
    setLoadingRequest(true);

    if(isNewFunc){
      const _data = await generateNewData();
      
      setOffsetDate(_data ?? []);
    } else {
      const _data = await generateData();
      
      setOvertimeData(_data?.overtimeData ?? []);
      setLeaveData(_data?.leaveData ?? []);
      setHolidayData(_data?.holidayData ?? []);
    }

    setLoadingRequest(false);
  }, [generateData, generateNewData, isNewFunc]);

  useEffect(() => {
    fetchData();
  }, [fetchData]);

  useEffect(()=>{
    const test = false;

    if(test){
      fetchDataOld();
    }
  }, [fetchDataOld])

  // for upload
  const handleBrowse = (e) => {
    const fileList = Array.from(e.target.files);

    setFiles(fileList);
  };
  const handleDrop = (e) => {
    e.preventDefault();

    const fileList = Array.from(e.dataTransfer.files);
    e.currentTarget.style.backgroundColor = "white";

    setFiles(fileList);
  };
  const handleDragOver = (e) => {
    e.preventDefault();
    e.currentTarget.style.backgroundColor = "#bdbdbd7d";
  };
  const handleDragOut = (e) => {
    e.preventDefault();
    e.currentTarget.style.backgroundColor = "white";
  };
  const clearFiles = () => {
    // Clear the files state
    setFiles([]);
    // Reset the value of the file input
    document.getElementById("fileInput").value = "";
  };

  // for upload gps cam
  const handleBrowseGPSCam = (e) => {
      const fileList = Array.from(e.target.files);

      /* if (fileList.length > 0) {
          if(!fileList[0].type.startsWith("image/")){
              alert("Please select an image file.");
              setFiles("");
              return;
          }
      } */

      setGPSCam(fileList);
  };
  const handleDropGPSCam = (e) => {
      e.preventDefault();
      
      const fileList = Array.from(e.dataTransfer.files);
      e.currentTarget.style.backgroundColor = "white";

      /* if (fileList.length > 0) {
          if(!fileList[0].type.startsWith("image/")){
              alert("Please select an image file.");
              setGPSCam("");
              return;
          }
      } */

      setGPSCam(fileList);
  };
  const handleDragOverGPSCam = (e) => {
      e.preventDefault();
      e.currentTarget.style.backgroundColor = "#bdbdbd7d";
  };
  const handleDragOutGPSCam = (e) => {
      e.preventDefault();
      e.currentTarget.style.backgroundColor = "white";
  };
  const clearFilesGPSCam = () => {
      // Clear the files state
      setGPSCam([]);
      // Reset the value of the file input
      document.getElementById('fileInput').value = '';
  };

  const [showReferenceForm, setShowReferenceForm] = useState(false);
  const openReferenceForm = () => {
    setShowReferenceForm(true);
  };
  const closeReferenceForm = () => {
    setShowReferenceForm(false);
  };
  const [showReferenceDateForm, setShowReferenceDateForm] = useState(false);
  const openReferenceDateForm = () => {
    setShowReferenceDateForm(true);
  };
  const closeReferenceDateForm = () => {
    setShowReferenceDateForm(false);
  };

  const [showReferenceHolidayDateForm, setShowReferenceHolidayDateForm] = useState(false);
  const openReferenceHolidayDateForm = () => {
    setShowReferenceHolidayDateForm(true);
  };
  const closeReferenceHolidayDateForm = () => {
    setShowReferenceHolidayDateForm(false);
  };

  const removeReferenceHolidayDate = (id) => {
    setReferenceHolidayDate((prev) => prev.filter((item) => item.id !== id));
  };
  const removeReferenceDate = (id) => {
    setReferenceDate((prev) => prev.filter((item) => item.id !== id));
  };
  const removeReference = (id) => {
    setReference((prev) => prev.filter((item) => item.id !== id));
  };

  useEffect(() => {
    const totalHours = referenceDate.reduce((sum, item) => sum + (item.hours || 0), 0);
    setHours(totalHours);
  }, [referenceDate]);

  useEffect(() => {
    const totalDays = reference.reduce((sum, item) => sum + (item.leaveData.days || 0), 0);
    setDays(totalDays);
  }, [reference]);

  useEffect(() => {
    const totalHolidayDays = referenceHolidayDate.reduce((sum, item) => sum + (item.days || 0), 0);
    setHolidayDays(totalHolidayDays);
  }, [referenceHolidayDate]);

  const formatTime = (time) => {
    if(!time){
      return ""
    }

    let timeParts;
    let formattedTime;

    const timeSplit = time.split('T');
    if (timeSplit.length > 1) {
        timeParts = timeSplit[1].substr(0, 5).split(':');
    } else {
        timeParts = [];
    }
    let hours = parseInt(timeParts[0], 10);
    const minutes = timeParts[1];

    // Convert 24-hour format to 12-hour format and determine AM or PM
    const amPm = hours >= 12 ? 'PM' : 'AM';
    hours = hours % 12 || 12; // Convert 0 to 12 for 12-hour format

    formattedTime = `${hours}:${minutes} ${amPm}`;

    return formattedTime
  }

  return (
    <div>
      <div className={`MainBody row ${isHideSideMenu ? "MainBody2" : ""}`}>
        <div className="LeftSpace"></div>
        <div className={`BodySpace ${isHideSideMenu ? "BodySpace2" : ""}`}>
          <div className="TransactionInfo Transaction-Form-Info">
            <div className="transaction-header">
              <div className="sub-title row">
                <span style={{ padding: "0 5px 0 0", color: "#b0b0b0" }}>
                  {"Transactions >"}{" "}
                </span>
                <span style={{ borderBottom: "1px solid black" }}>
                  {"Offset Request / Overtime Food Allowance"}
                </span>
              </div>
              <div
                className="row"
                style={{
                  alignItems: "center",
                  justifyContent: "space-between",
                }}
              >
                <h3>Offset Request / Overtime Food Allowance</h3>
                <div className="transaction-form-upper row">
                  {testSMS && (
                    <>
                      {CreateButton(
                        "overtime-add-button",
                        "viewHistory row",
                        sendSmsTrial,
                        "SEND SMS",
                        RemoveRedEyeIcon
                      )}
                    </>
                  )}
                  {CreateButton(
                    "overtime-add-button",
                    "viewHistory row",
                    openViewHistoryForm,
                    "VIEW HISTORY",
                    RemoveRedEyeIcon
                  )}
                </div>
              </div>
            </div>
            <div className="transaction-body">
              <div
                style={{
                  display: "none",
                  flexDirection: "column",
                  padding: "10px",
                  background: "white",
                  border: "1px solid #aaa",
                  borderRadius: "5px",
                  width: "max-content",
                }}
              >
                <span>{`Offset Hours: ${overtimeData.totalHours?.toLocaleString(
                  "en-US",
                  {
                    minimumFractionDigits: 2,
                    maximumFractionDigits: 2,
                  }
                )}`}</span>
                <span>{`Offset Days: ${leaveData.totalDays?.toLocaleString(
                  "en-US",
                  {
                    minimumFractionDigits: 2,
                    maximumFractionDigits: 2,
                  }
                )}`}</span>
              </div>

              <div className="transaction-from-splitItem row">
                <div className="column" style={{ width: "100%" }}>
                  <div className="transaction-form-item row">
                    <div className="transaction-form-category">
                      <h4>Employee</h4>
                    </div>
                    <div className="transaction-form-input">
                      <div
                        className="info-item-holder employee-select row"
                        style={{
                          flexDirection: "row",
                          justifyContent: "normal",
                        }}
                      >
                        <input
                          readOnly
                          className="employeeInput-select"
                          placeholder="Employee"
                          value={employee ? employee : employee}
                        />
                        <button
                          className="select row"
                          onClick={() => setShowEmployeeForm(true)}
                          style={{
                            visibility:
                              userAccess.description === "Admin" ||
                              userAccess.description === "HR Head" ||
                              userAccess.description === "HR Assistant" ||
                              userAccess.description === "HR Assistant2" ||
                              userAccess.description === "HR Assistant3" ||
                              userAccess.description === "HR Manager"
                                ? "visible"
                                : "hidden",
                          }}
                        >
                          <SearchIcon />
                        </button>
                      </div>
                    </div>
                  </div>
                  <span
                    style={{
                      marginTop: "-10px",
                      display: "flex",
                      justifyContent: "center",
                      visibility:
                        !employee && errorState ? "visible" : "hidden",
                      color: "#ff6565",
                      fontSize: "12px",
                    }}
                  >
                    Please fill up this field
                  </span>
                </div>
                <div className="column hidden" style={{ width: "100%" }}>
                  <div className="transaction-form-item row">
                    <div className="transaction-form-category">
                      <h4>Type</h4>
                    </div>
                    <div className="transaction-form-input">
                      <TypeSelect data={type} setData={setType} />
                    </div>
                  </div>
                  <span
                    style={{
                      marginTop: "-10px",
                      display: "flex",
                      justifyContent: "center",
                      visibility: !type && errorState ? "visible" : "hidden",
                      color: "#ff6565",
                      fontSize: "12px",
                    }}
                  >
                    Please fill up this field
                  </span>
                </div>
                <div className="column" style={{ width: "100%" }}>
                </div>
              </div>
              <div className="transaction-from-splitItem row">
                <div className="column hidden" style={{ width: "100%" }}>
                  <div className="transaction-form-item row">
                    <div className="transaction-form-category">
                      <h4>Reference Date/s</h4>
                    </div>
                    <div className="transaction-form-input">
                      <div
                        className="info-item-holder employee-select row"
                        style={{
                          flexDirection: "row",
                          justifyContent: "normal",
                        }}
                      >
                        <input
                          readOnly
                          className="employeeInput-select"
                          placeholder="Reference Date"
                          value={referenceDate?.date ? referenceDate.date.split("T")[0] : ""}
                        />
                        <button
                          className="select row"
                          onClick={openReferenceDateForm}
                        >
                          <SearchIcon />
                        </button>
                      </div>
                    </div>
                  </div>
                  <span
                    style={{
                      marginTop: "-10px",
                      display: "flex",
                      justifyContent: "center",
                      visibility:
                        !referenceDate && errorState ? "visible" : "hidden",
                      color: "#ff6565",
                      fontSize: "12px",
                    }}
                  >
                    Please fill up this field
                  </span>
                </div>

                <div className="column" style={{ width: "100%" }}>
                  <div className="transaction-form-item row">
                    <div className="transaction-form-category">
                      <h4>Reference Date/s</h4>
                    </div>
                    <div className="transaction-form-input">
                      <div
                        className="info-item-holder employee-select row"
                        style={{
                          flexDirection: "column",
                          justifyContent: "start",
                          alignItems: "start",
                          gap: "10px",
                        }}
                      >
                        { referenceDate.length <= 0 &&
                          <div>
                            {CreateButton(
                              "overtime-add-button",
                              "add-reference row",
                              openReferenceDateForm,
                              "ADD REFERENCE",
                              AddIcon
                            )}
                          </div>
                        }

                        {/* {referenceDate.map((item) => {
                          return (
                            // <div key={item.id} className="flex flex-row gap-5" style={{display: "flex", flexDirection: "column"}}>
                            <div key={item.id} className="flex flex-row gap-5" style={{display: "flex", gap: "5px"}}>
                              <span>{item?.date ? `Date: ${item.date.split("T")[0]}` : ""}</span>
                              <span>{item?.timeIn ? `Time In: ${formatTime(item?.timeIn)}` : ""}</span>
                              <span>{item?.timeOut ? `Time Out: ${formatTime(item?.timeOut)}` : ""}</span>
                              <button className="bg-red-400 hover:bg-red-500 hover:cursor-pointer border-none text-white rounded-sm"
                                onClick={()=>removeReferenceDate(item.id)}
                              >remove</button>
                            </div>
                          );
                        })} */}
                        {referenceDate.map((item) => {
                          return (
                          <div key={item.id} className="attendance-card">
                            <div className="attendance-info">
                              {/* Date Section */}
                              <div className="info-group">
                                <span className="label label-date">Date</span>
                                <span className="value">
                                  {item?.date ? item.date.split("T")[0] : "—"}
                                </span>
                              </div>

                              {/* Time In Section */}
                              <div className="info-group">
                                <span className="label label-in">Time In</span>
                                <span className="value font-bold">
                                  {item?.timeIn ? formatTime(item?.timeIn) : "—"}
                                </span>
                              </div>

                              {/* Time Out Section */}
                              <div className="info-group">
                                <span className="label label-out">Time Out</span>
                                <span className="value font-bold">
                                  {item?.timeOut ? formatTime(item?.timeOut) : "—"}
                                </span>
                              </div>
                            </div>

                            {/* Action Button */}
                            <button 
                              className="remove-btn"
                              onClick={() => removeReferenceDate(item.id)}
                            >
                              Remove
                            </button>
                          </div>
                          );
                        })}
                      </div>
                    </div>
                  </div>
                  <span
                    style={{
                      marginTop: "-10px",
                      display: "flex",
                      justifyContent: "center",
                      visibility:
                        referenceDate.length <= 0 && errorState ? "visible" : "hidden",
                      color: "#ff6565",
                      fontSize: "12px",
                    }}
                  >
                    Please fill up this field
                  </span>
                </div>

                <div className="column" style={{ width: "100%" }}>
                  <div className="transaction-form-item row">
                    <div className="transaction-form-category">
                      <h4>Date (To Use)</h4>
                    </div>
                    <div className="transaction-form-input">
                      <DateTimeInput
                        date={date}
                        setDate={setDate}
                      />
                    </div>
                  </div>
                </div>
              </div>
              {referenceDate != null && referenceDate.length > 0 && <div className="transaction-from-splitItem row">
                <div className="column" style={{ width: "100%" }}>
                  <div className="transaction-form-item row">
                    <div className="transaction-form-category">
                      <h4>Offset Type </h4>
                    </div>
                    <div className="transaction-form-input">
                      <div className="row" style={{ gap: "30px", display: "flex", alignItems: "center", height: "100%" }}>
                        { new Date(referenceDate[0].timeOut).getHours() >= 2 && new Date(referenceDate[0].timeOut).getHours() < 6 &&
                          <label style={{ display: "flex", alignItems: "center", gap: "8px", cursor: "pointer", color: "rgb(104, 104, 104)", fontWeight: "500" }}>
                            <input
                              type="radio"
                              name="offsetType"
                              value="wholeday"
                              checked={offsetType === "wholeday"}
                              onChange={(e) => setOffsetType(e.target.value)}
                              style={{ width: "18px", height: "18px", cursor: "pointer" }}
                            />
                            Wholeday Offset
                          </label>
                        }

                        { new Date(referenceDate[0].timeOut).getHours() >= 0 && new Date(referenceDate[0].timeOut).getHours() < 2 &&
                          <label style={{ display: "flex", alignItems: "center", gap: "8px", cursor: "pointer", color: "rgb(104, 104, 104)", fontWeight: "500" }}>
                            <input
                              type="radio"
                              name="offsetType"
                              value="halfday"
                              checked={offsetType === "halfday"}
                              onChange={(e) => setOffsetType(e.target.value)}
                              style={{ width: "18px", height: "18px", cursor: "pointer" }}
                            />
                            Halfday Offset
                          </label>
                        }

                        { new Date(referenceDate[0].timeOut).getHours() >= 22 && new Date(referenceDate[0].timeOut).getHours() < 24 &&
                          <label style={{ display: "flex", alignItems: "center", gap: "8px", cursor: "pointer", color: "rgb(104, 104, 104)", fontWeight: "500" }}>
                            <input
                              type="radio"
                              name="offsetType"
                              value="foodAllowance250"
                              checked={offsetType === "foodAllowance250"}
                              onChange={(e) => setOffsetType(e.target.value)}
                              style={{ width: "18px", height: "18px", cursor: "pointer" }}
                            />
                            Food Allowance
                          </label>
                        }

                        { new Date(referenceDate[0].timeOut).getHours() >= 0 && new Date(referenceDate[0].timeOut).getHours() < 6 &&
                          <label style={{ display: "flex", alignItems: "center", gap: "8px", cursor: "pointer", color: "rgb(104, 104, 104)", fontWeight: "500" }}>
                            <input
                              type="radio"
                              name="offsetType"
                              value="foodAllowance350"
                              checked={offsetType === "foodAllowance350"}
                              onChange={(e) => setOffsetType(e.target.value)}
                              style={{ width: "18px", height: "18px", cursor: "pointer" }}
                            />
                            Food Allowance
                          </label>
                        }
                      </div>
                    </div>
                  </div>
                </div>

                <div className="column" style={{ width: "100%" }}>
                  
                </div>
              </div>}
              <div className="hidden">
                {type === "Overtime" && (
                  <>
                  <div className="transaction-from-splitItem row">
                    <div className="column hidden" style={{ width: "100%" }}>
                      <div className="transaction-form-item row">
                        <div className="transaction-form-category">
                          <h4>Reference Date/s</h4>
                        </div>
                        <div className="transaction-form-input">
                          <div
                            className="info-item-holder employee-select row"
                            style={{
                              flexDirection: "row",
                              justifyContent: "normal",
                            }}
                          >
                            <input
                              readOnly
                              className="employeeInput-select"
                              placeholder="Reference Date"
                              value={referenceDate?.date ? referenceDate.date.split("T")[0] : ""}
                            />
                            <button
                              className="select row"
                              onClick={openReferenceDateForm}
                            >
                              <SearchIcon />
                            </button>
                          </div>
                        </div>
                      </div>
                      <span
                        style={{
                          marginTop: "-10px",
                          display: "flex",
                          justifyContent: "center",
                          visibility:
                            !referenceDate && errorState ? "visible" : "hidden",
                          color: "#ff6565",
                          fontSize: "12px",
                        }}
                      >
                        Please fill up this field
                      </span>
                    </div>

                    <div className="column" style={{ width: "100%" }}>
                      <div className="transaction-form-item row">
                        <div className="transaction-form-category">
                          <h4>Reference Date/s</h4>
                        </div>
                        <div className="transaction-form-input">
                          <div
                            className="info-item-holder employee-select row"
                            style={{
                              flexDirection: "column",
                              justifyContent: "start",
                              alignItems: "start",
                              gap: "10px",
                            }}
                          >
                            <div>
                              {CreateButton(
                                "overtime-add-button",
                                "add-reference row",
                                openReferenceDateForm,
                                "ADD REFERENCE",
                                AddIcon
                              )}
                            </div>

                            {referenceDate.map((item) => {
                              return (
                                <div key={item.id} className="flex flex-row gap-5">
                                  <span>{item?.date ? `Date: ${item.date.split("T")[0]}` : ""}</span>
                                  <span>{item?.hours ? `Hours: ${item.hours}` : ""}</span>
                                  <button className="bg-red-400 hover:bg-red-500 hover:cursor-pointer border-none text-white rounded-sm"
                                    onClick={()=>removeReferenceDate(item.id)}
                                  >remove</button>
                                </div>
                              );
                            })}
                          </div>
                        </div>
                      </div>
                      <span
                        style={{
                          marginTop: "-10px",
                          display: "flex",
                          justifyContent: "center",
                          visibility:
                            referenceDate.length <= 0 && errorState ? "visible" : "hidden",
                          color: "#ff6565",
                          fontSize: "12px",
                        }}
                      >
                        Please fill up this field
                      </span>
                    </div>

                    <div className="column" style={{ width: "100%" }}>
                      <div className="transaction-form-item row">
                        <div className="transaction-form-category">
                          <h4>Date (To Use)</h4>
                        </div>
                        <div className="transaction-form-input">
                          <DateTimeInput
                            date={date}
                            setDate={setDate}
                          />
                        </div>
                      </div>
                    </div>
                  </div>
                  <div className="transaction-from-splitItem row">
                    <div className="column" style={{ width: "100%" }}>
                      <div className="transaction-form-item row">
                        <div className="transaction-form-category">
                          <h4>Hours</h4>
                        </div>
                        <div className="transaction-form-input info-item">
                          <input
                            type="number"
                            id="hours"
                            placeholder="Hours"
                            value={hours}
                            onChange={(e) => setHours(e.target.value)}
                          />
                        </div>
                      </div>
                      <span
                        style={{
                          marginTop: "0px",
                          display: "flex",
                          justifyContent: "center",
                          visibility: !hours && errorState ? "visible" : "hidden",
                          color: "#ff6565",
                          fontSize: "12px",
                        }}
                      >
                        Please fill up this field
                      </span>
                    </div>
                    <div className="column" style={{ width: "100%", visibility: "hidden" }}>
                      <div className="transaction-form-item row">
                        <div className="transaction-form-category">
                          <h4>Hours</h4>
                        </div>
                        <div className="transaction-form-input info-item">
                          <input
                            type="number"
                            id="hours"
                            placeholder="Hours"
                            value={hours}
                          />
                        </div>
                      </div>
                      <span
                        style={{
                          marginTop: "0px",
                          display: "flex",
                          justifyContent: "center",
                          visibility: !hours && errorState ? "visible" : "hidden",
                          color: "#ff6565",
                          fontSize: "12px",
                        }}
                      >
                        Please fill up this field
                      </span>
                    </div>
                  </div>
                  </>
                )}
                {type === "Leave" && (
                  <>
                    <div className="transaction-from-splitItem row">
                      <div className="column hidden" style={{ width: "100%" }}>
                        <div className="transaction-form-item row">
                          <div className="transaction-form-category">
                            <h4>Reference</h4>
                          </div>
                          <div className="transaction-form-input">
                            <div
                              className="info-item-holder employee-select row"
                              style={{
                                flexDirection: "row",
                                justifyContent: "normal",
                              }}
                            >
                              <input
                                readOnly
                                className="employeeInput-select"
                                placeholder="Reference"
                                value={
                                  reference
                                    ? `OS-${reference?.leaveData?.referenceNumber
                                        ?.toString()
                                        .padStart(6, "0")}`
                                    : ""
                                }
                              />
                              <button
                                className="select row"
                                onClick={openReferenceForm}
                              >
                                <SearchIcon />
                              </button>
                            </div>
                          </div>
                        </div>
                        <span
                          style={{
                            marginTop: "-10px",
                            display: "flex",
                            justifyContent: "center",
                            visibility:
                              !reference && errorState ? "visible" : "hidden",
                            color: "#ff6565",
                            fontSize: "12px",
                          }}
                        >
                          Please fill up this field
                        </span>
                      </div>
                      <div className="column" style={{ width: "100%" }}>
                        <div className="transaction-form-item row">
                          <div className="transaction-form-category">
                            <h4>Reference</h4>
                          </div>
                          <div className="transaction-form-input">
                            <div
                              className="info-item-holder employee-select row"
                              style={{
                                flexDirection: "column",
                                justifyContent: "start",
                                alignItems: "start",
                                gap: "10px",
                              }}
                            >
                              <div>
                                {CreateButton(
                                  "overtime-add-button",
                                  "add-reference row",
                                  openReferenceForm,
                                  "ADD REFERENCE",
                                  AddIcon
                                )}
                              </div>

                              {reference.map((item) => {
                                return (
                                  <div key={item.id} className="flex flex-row gap-5">
                                    <span>{item?.leaveData ? `Reference Number: LV-${item?.leaveData?.referenceNumber?.toString().padStart(6, "0")}` : ""}</span>
                                    <span>{item?.leaveData?.days ? `Days: ${item?.leaveData?.days}` : ""}</span>
                                    <button className="bg-red-400 hover:bg-red-500 hover:cursor-pointer border-none text-white rounded-sm"
                                      onClick={()=>removeReference(item.id)}
                                    >remove</button>
                                  </div>
                                );
                              })}
                            </div>
                          </div>
                        </div>
                        <span
                          style={{
                            marginTop: "-10px",
                            display: "flex",
                            justifyContent: "center",
                            visibility:
                              reference.length <= 0 && errorState ? "visible" : "hidden",
                            color: "#ff6565",
                            fontSize: "12px",
                          }}
                        >
                          Please fill up this field
                        </span>
                      </div>
                      <div className="column" style={{ width: "100%" }}>
                        <div className="transaction-form-item row">
                          <div className="transaction-form-category">
                            <h4>Days</h4>
                          </div>
                          <div className="transaction-form-input info-item">
                            <input
                              type="number"
                              id="hours"
                              placeholder="Days"
                              value={days}
                              onChange={(e) => setDays(e.target.value)}
                            />
                          </div>
                        </div>
                        <span
                          style={{
                            marginTop: "0px",
                            display: "flex",
                            justifyContent: "center",
                            visibility:
                              !days && errorState ? "visible" : "hidden",
                            color: "#ff6565",
                            fontSize: "12px",
                          }}
                        >
                          Please fill up this field
                        </span>
                      </div>
                    </div>
                    <div className="transaction-from-splitItem row">
                      <div className="column" style={{ width: "100%" }}>
                        <div className="transaction-form-item row">
                          <div className="transaction-form-category">
                            <h4>Date From (To Use)</h4>
                          </div>
                          <div className="transaction-form-input">
                            <DateTimeInput
                              date={dateFrom}
                              setDate={setDateFrom}
                            />
                          </div>
                        </div>
                        <span
                          style={{
                            marginTop: "-10px",
                            display: "flex",
                            justifyContent: "center",
                            visibility:
                              !date && errorState ? "visible" : "hidden",
                            color: "#ff6565",
                            fontSize: "12px",
                          }}
                        >
                          Please fill up this field
                        </span>
                      </div>
                      <div className="column" style={{ width: "100%" }}>
                        <div className="transaction-form-item row">
                          <div className="transaction-form-category">
                            <h4>Date To (To Use)</h4>
                          </div>
                          <div className="transaction-form-input">
                            <DateTimeInput date={dateTo} setDate={setDateTo} />
                          </div>
                        </div>
                        <span
                          style={{
                            marginTop: "-10px",
                            display: "flex",
                            justifyContent: "center",
                            visibility:
                              !date && errorState ? "visible" : "hidden",
                            color: "#ff6565",
                            fontSize: "12px",
                          }}
                        >
                          Please fill up this field
                        </span>
                      </div>
                    </div>
                  </>
                )}
                {type === "Holiday" && (
                  <>
                  <div className="transaction-from-splitItem row">
                    <div className="column hidden" style={{ width: "100%" }}>
                      <div className="transaction-form-item row">
                        <div className="transaction-form-category">
                          <h4>Reference Date/s</h4>
                        </div>
                        <div className="transaction-form-input">
                          <div
                            className="info-item-holder employee-select row"
                            style={{
                              flexDirection: "row",
                              justifyContent: "normal",
                            }}
                          >
                            <input
                              readOnly
                              className="employeeInput-select"
                              placeholder="Reference Date"
                              value={referenceHolidayDate?.date ? referenceHolidayDate.date.split("T")[0] : ""}
                            />
                            <button
                              className="select row"
                              onClick={openReferenceHolidayDateForm}
                            >
                              <SearchIcon />
                            </button>
                          </div>
                        </div>
                      </div>
                      <span
                        style={{
                          marginTop: "-10px",
                          display: "flex",
                          justifyContent: "center",
                          visibility:
                            !referenceDate && errorState ? "visible" : "hidden",
                          color: "#ff6565",
                          fontSize: "12px",
                        }}
                      >
                        Please fill up this field
                      </span>
                    </div>

                    <div className="column" style={{ width: "100%" }}>
                      <div className="transaction-form-item row">
                        <div className="transaction-form-category">
                          <h4>Reference Date/s</h4>
                        </div>
                        <div className="transaction-form-input">
                          <div
                            className="info-item-holder employee-select row"
                            style={{
                              flexDirection: "column",
                              justifyContent: "start",
                              alignItems: "start",
                              gap: "10px",
                            }}
                          >
                            <div>
                              {CreateButton(
                                "overtime-add-button",
                                "add-reference row",
                                openReferenceHolidayDateForm,
                                "ADD REFERENCE",
                                AddIcon
                              )}
                            </div>

                            {referenceHolidayDate.map((item) => {
                              return (
                                <div key={item.id} className="flex flex-row gap-5">
                                  <span>{item?.date ? `Date: ${item.date.split("T")[0]}` : ""}</span>
                                  <span>{item?.hours ? `Hours: ${item.hours}` : ""}</span>
                                  <button className="bg-red-400 hover:bg-red-500 hover:cursor-pointer border-none text-white rounded-sm"
                                    onClick={()=>removeReferenceHolidayDate(item.id)}
                                  >remove</button>
                                </div>
                              );
                            })}
                          </div>
                        </div>
                      </div>
                      <span
                        style={{
                          marginTop: "-10px",
                          display: "flex",
                          justifyContent: "center",
                          visibility:
                            referenceDate.length <= 0 && errorState ? "visible" : "hidden",
                          color: "#ff6565",
                          fontSize: "12px",
                        }}
                      >
                        Please fill up this field
                      </span>
                    </div>

                    <div className="column" style={{ width: "100%" }}>
                      <div className="transaction-form-item row">
                        <div className="transaction-form-category">
                          <h4>Date (To Use)</h4>
                        </div>
                        <div className="transaction-form-input">
                          <DateTimeInput
                            date={holidayDate}
                            setDate={setHolidayDate}
                          />
                        </div>
                      </div>
                    </div>
                  </div>
                  <div className="transaction-from-splitItem row">
                    <div className="column" style={{ width: "100%" }}>
                      <div className="transaction-form-item row">
                        <div className="transaction-form-category">
                          <h4>Days</h4>
                        </div>
                        <div className="transaction-form-input info-item">
                          <input
                            type="number"
                            id="hours"
                            placeholder="Hours"
                            value={holidayDays}
                            onChange={(e) => setHolidayDays(e.target.value)}
                          />
                        </div>
                      </div>
                      <span
                        style={{
                          marginTop: "0px",
                          display: "flex",
                          justifyContent: "center",
                          visibility: !hours && errorState ? "visible" : "hidden",
                          color: "#ff6565",
                          fontSize: "12px",
                        }}
                      >
                        Please fill up this field
                      </span>
                    </div>
                    <div className="column" style={{ width: "100%", visibility: "hidden" }}>
                      <div className="transaction-form-item row">
                        <div className="transaction-form-category">
                          <h4>Hours</h4>
                        </div>
                        <div className="transaction-form-input info-item">
                          <input
                            type="number"
                            id="hours"
                            placeholder="Hours"
                            value={hours}
                          />
                        </div>
                      </div>
                      <span
                        style={{
                          marginTop: "0px",
                          display: "flex",
                          justifyContent: "center",
                          visibility: !hours && errorState ? "visible" : "hidden",
                          color: "#ff6565",
                          fontSize: "12px",
                        }}
                      >
                        Please fill up this field
                      </span>
                    </div>
                  </div>
                  </>
                )}
              </div>
              <div
                className="transaction-form-item row"
                style={{ paddingTop: "50px", alignItems: "revert" }}
              >
                <div className="transaction-form-category">
                  <h4>Reason</h4>
                </div>
                <div className="transaction-form-input">
                  <textarea
                    id="overtime-tamper"
                    style={{
                      width: "95%",
                      minHeight: "100px",
                      borderRadius: "3px",
                      border: "1px solid #80808080",
                      color: "rgb(104, 104, 104)",
                    }}
                    value={reason}
                    onChange={(e) => setReason(e.target.value)}
                  />
                </div>
              </div>
              
              <div className="transaction-form-item row" style={{paddingTop:"50px", alignItems:"revert"}}>
                  <div className="transaction-form-category"><h4 style={{margin:'0'}}>GPS Cam Attachment</h4></div>
                  <div className="transaction-form-input">
                      <label htmlFor="fileInputGPSCam" className='browse'>Browse...</label>
                      <input
                          type="file"
                          id="fileInputGPSCam"
                          onChange={(e)=> handleBrowseGPSCam(e)}
                          style={{ display: 'none' }}
                      />
                      
                      {gpsCam.length > 0 ? (
                          <div style={{border:"1px solid #97979745", padding:"10px"}}>
                              <span>Uploaded File:</span>
                              <ul>
                                  {gpsCam.map((file, index) => (
                                  <span key={index}>{file.name}</span>
                                  ))}
                              </ul>
                              <div className="buttons row" style={{display:"flex", justifyContent:"end"}}>
                                  <button id="add-family" 
                                  className="cancel row"
                                  onClick={()=>clearFilesGPSCam()}
                                  style={{marginRight:"5px"}}>
                                      CLEAR
                                  </button>
                              </div>
                          </div>
                      )
                      :
                      (
                          <div
                              id='drop-files-here'
                              onDrop={(e)=>handleDropGPSCam(e)}
                              onDragOver={(e)=>handleDragOverGPSCam(e)}
                              onDragLeave={(e)=>handleDragOutGPSCam(e)}
                              style={{
                              border: '2px dashed #ccc',
                              borderRadius: '5px',
                              padding: '20px',
                              marginTop: '10px',
                              textAlign: 'center',
                              }}
                          >
                              Drop files here
                          </div>
                      )}
                  </div>
              </div>
              <div
                className="transaction-form-item row"
                style={{ paddingTop: "50px", alignItems: "revert" }}
              >
                <div className="transaction-form-category">
                  <h4>Attached Proof of Approval</h4>
                </div>
                <div className="transaction-form-input">
                  <label htmlFor="fileInput" className="browse">
                    Browse...
                  </label>
                  <input
                    type="file"
                    id="fileInput"
                    onChange={(e) => handleBrowse(e)}
                    style={{ display: "none" }}
                  />

                  {files?.length > 0 ? (
                    <div
                      style={{ border: "1px solid #97979745", padding: "10px" }}
                    >
                      <span>Uploaded File:</span>
                      <ul>
                        {files.map((file, index) => (
                          <span key={index}>{file.name}</span>
                        ))}
                      </ul>
                      <div
                        className="buttons row"
                        style={{ display: "flex", justifyContent: "end" }}
                      >
                        <button
                          id="add-family"
                          className="cancel row"
                          onClick={() => clearFiles()}
                          style={{ marginRight: "5px" }}
                        >
                          CLEAR
                        </button>
                      </div>
                    </div>
                  ) : (
                    <div
                      id="drop-files-here"
                      onDrop={(e) => handleDrop(e)}
                      onDragOver={(e) => handleDragOver(e)}
                      onDragLeave={(e) => handleDragOut(e)}
                      style={{
                        border: "2px dashed #ccc",
                        borderRadius: "5px",
                        padding: "20px",
                        marginTop: "10px",
                        textAlign: "center",
                      }}
                    >
                      Drop files here
                    </div>
                  )}
                </div>
              </div>
              <div className="transaction-form-footer">
                {CreateButton(
                  "overtime-add-button",
                  "submit",
                  (e) => submit(e),
                  "SEND REQUEST",
                  ""
                )}
              </div>
            </div>
          </div>
        </div>
      </div>
      <ViewHistoryForm
        isOpen={showVieHistoryForm}
        onClose={closeViewHistoryForm}
        user={user}
      ></ViewHistoryForm>
      <EmployeeSelectForm
        isOpen={showEmployeeForm}
        user={user}
        onClose={closeEmployeeForm}
        setEmployeeId={setEmployeeId}
        setEmployee={setEmployee}
      ></EmployeeSelectForm>
      { showReferenceForm &&
      <ReferenceSelectForm
        isOpen={showReferenceForm}
        onClose={closeReferenceForm}
        leaveData={leaveData}
        reference={reference}
        setReference={setReference}
        setDays={setDays}
        user={user}
      ></ReferenceSelectForm>
      }
      { showReferenceDateForm &&
      <>
        { isNewFunc ?
          <ReferenceOffsetDateSelectForm
            isOpen={showReferenceDateForm}
            onClose={closeReferenceDateForm}
            overtimeData={offsetDate}
            reference={referenceDate}
            setReference={setReferenceDate}
            setHours={setHours}
            user={user}
          ></ReferenceOffsetDateSelectForm>
          :
          <ReferenceDateSelectForm
            isOpen={showReferenceDateForm}
            onClose={closeReferenceDateForm}
            overtimeData={overtimeData}
            reference={referenceDate}
            setReference={setReferenceDate}
            setHours={setHours}
            user={user}
            setOffsetType={setOffsetType}
          ></ReferenceDateSelectForm>
        }
      </>
      }
      { showReferenceHolidayDateForm &&
      <ReferenceHolidayDateSelectForm
        isOpen={showReferenceHolidayDateForm}
        onClose={closeReferenceHolidayDateForm}
        holidayData={holidayData}
        setHolidayDate={setHolidayDate}
        referenceHolidayDate={referenceHolidayDate}
        setReferenceHolidayDate={setReferenceHolidayDate}
        setHolidayDays={setHolidayDays}
        user={user}
      ></ReferenceHolidayDateSelectForm>
      }
      <GenerateMessage
        form={showRequestMessage}
        message={isSuccess ? "Request Success!" : requestMessage}
        isSuccess={isSuccess}
      ></GenerateMessage>
      {loadingRequest ? (
        <div
          style={{
            position: "fixed",
            top: "0",
            left: "0",
            width: "100vw",
            height: "100vh",
            zIndex: "2000",
            display: "flex",
            flexDirection: "column",
            alignItems: "center",
            justifyContent: "center",
            textAlign: "center",
            backgroundColor: "#ffffff59",
          }}
        >
          <img src={loadingSpinner} alt="Loading..." />
        </div>
      ) : (
        <></>
      )}
    </div>
  );
}

function ReferenceSelectForm({ isOpen, onClose, leaveData, reference, setReference, setDays, user }) {
  var header = [
    "Leave Ref No.",
    // "Employee",
    "Type",
    "Date From",
    "Date To",
    "Days",
    "Used",
    "Remaining",
  ];
  var accessor = [
    "leaveData.referenceNumber",
    // "employeePersonalInformationFullName",
    "leaveData.leaveTypeDescription",
    "leaveData.dateFrom",
    "leaveData.dateTo",
    "leaveData.days",
    "useValue",
    "remainingValue",
  ];

  // const [data, setData] = useState([]);
  const [selectedReference, setSelectedReference] = useState([]);

  const handleClose = () => {
    onClose();
    //fetchData();
  };
  const handleProceed = () => {
    /* onClose();
    if (selectedReference?.length !== 0) {
      setReference(selectedReference);
      setDays(selectedReference?.leaveData?.days);
    }
    fetchData(); */

    if (selectedReference?.length !== 0) {
      const foundReference = reference.find(i => i.id === selectedReference.id)

      if(foundReference){
        alert("Already added this reference");
      } else 
      {
        setReference((prev) => [...prev, selectedReference]);
        //fetchData();
        onClose();
      }
    }
  };

  return (
    <>
      <div className={`modal-overlay ${isOpen ? "open" : ""}`}>
        {isOpen && (
          <div className="modal">
            <div className="popUp-header row">
              <div className="popUp-title">
                <h3 style={{ color: "#668fca" }}>Select Reference Id</h3>
              </div>
              <div className="popUp-close">
                <CloseIcon onClick={() => handleClose()} />
              </div>
            </div>
            <div className="popUp-body selectModal">
              <div className="select-employee-table">
                <CreateTableForReferenceSelect
                  dataList={leaveData?.data ?? []}
                  dataHeader={header}
                  dataAccessor={accessor}
                  setSelectedReference={setSelectedReference}
                  // viewHandleClick={viewHandleClick}
                />
                {leaveData?.data?.length > 0 ? (
                  <div></div>
                ) : (
                  <div> {/*<p>No records to display</p>*/}</div>
                )}
              </div>
            </div>
            <div
              className="buttons row"
              style={{ justifyContent: "end", padding: "50px 20px 0 20px" }}
            >
              <button
                id="add-family"
                className="save row"
                onClick={handleProceed}
              >
                PROCEED
              </button>
            </div>
          </div>
        )}
      </div>
    </>
  );
}
function ReferenceDateSelectForm({ isOpen, onClose, overtimeData, reference, setReference, setHours, user, setOffsetType }) {
  var header = [
    "Date",
    "Remaining",
  ];
  var accessor = [
    "date",
    "remainingValue",
  ];

  // const [data, setData] = useState([]);
  const [selectedReference, setSelectedReference] = useState(null);

  const handleClose = () => {
    onClose();
    // fetchData();
  };
  const handleProceed = () => {
    if (selectedReference?.length !== 0) {
      const foundReference = reference.find(i => i.id === selectedReference.id)

      if(foundReference){
        alert("Already added this reference");
      } else 
      {
        setReference((prev) => [...prev, selectedReference]);

        if(setOffsetType){
          setOffsetType("")
        }
        // fetchData();
        onClose();
      }
    }
  };

  /* const fetchData = useCallback(async () => {
    const apiUrl = `${domain}/api/OffsetOvertime/employee/${user.employeePersonalInformationId}`;

    try {
      const response = await axios.get(apiUrl, {
        headers: {
          Authorization: `Bearer ${token}`,
          "Content-Type": "application/json",
        },
      });

      setData(response.data);
    } catch (error) {
      console.error("Error fetching leave data:", error);
    }
  }, [user]);

  useEffect(() => {
    fetchData();
  }, [fetchData]); */

  return (
    <>
      <div className={`modal-overlay ${isOpen ? "open" : ""}`}>
        {isOpen && (
          <div className="modal">
            <div className="popUp-header row">
              <div className="popUp-title">
                <h3 style={{ color: "#668fca" }}>Select Reference Date</h3>
              </div>
              <div className="popUp-close">
                <CloseIcon onClick={() => handleClose()} />
              </div>
            </div>
            <div className="popUp-body selectModal">
              <div className="select-employee-table">
                <CreateTableForReferenceSelect
                  dataList={overtimeData?.data ?? []}
                  dataHeader={header}
                  dataAccessor={accessor}
                  setSelectedReference={setSelectedReference}
                  // viewHandleClick={viewHandleClick}
                />
                {overtimeData?.data?.length > 0 ? (
                  <div></div>
                ) : (
                  <div> {/*<p>No records to display</p>*/}</div>
                )}
              </div>
            </div>
            <div
              className="buttons row"
              style={{ justifyContent: "end", padding: "50px 20px 0 20px" }}
            >
              <button
                id="add-family"
                className="save row"
                onClick={handleProceed}
              >
                PROCEED
              </button>
            </div>
          </div>
        )}
      </div>
    </>
  );
}
function ReferenceHolidayDateSelectForm({ isOpen, onClose, 
  holidayData,
  setHolidayDate,
  referenceHolidayDate,
  setReferenceHolidayDate,
  setHolidayDays,
  user 
}) {
  var header = [
    "Date",
    "Days",
    "Remaining",
  ];
  var accessor = [
    "date",
    "days",
    "remainingValue",
  ];

  const [selectedReference, setSelectedReference] = useState(null);

  const handleClose = () => {
    onClose();
    // fetchData();
  };
  const handleProceed = () => {
    if (selectedReference?.length !== 0) {
      const foundReference = referenceHolidayDate.find(i => i.id === selectedReference.id)

      if(foundReference){
        alert("Already added this reference");
      } else 
      {
        setReferenceHolidayDate((prev) => [...prev, selectedReference]);
        // fetchData();
        onClose();
      }
    }
  };

  /* const fetchData = useCallback(async () => {
    const apiUrl = `${domain}/api/OffsetOvertime/employee/${user.employeePersonalInformationId}`;

    try {
      const response = await axios.get(apiUrl, {
        headers: {
          Authorization: `Bearer ${token}`,
          "Content-Type": "application/json",
        },
      });

      setData(response.data);
    } catch (error) {
      console.error("Error fetching leave data:", error);
    }
  }, [user]);

  useEffect(() => {
    fetchData();
  }, [fetchData]); */

  return (
    <>
      <div className={`modal-overlay ${isOpen ? "open" : ""}`}>
        {isOpen && (
          <div className="modal">
            <div className="popUp-header row">
              <div className="popUp-title">
                <h3 style={{ color: "#668fca" }}>Select Reference Date</h3>
              </div>
              <div className="popUp-close">
                <CloseIcon onClick={() => handleClose()} />
              </div>
            </div>
            <div className="popUp-body selectModal">
              <div className="select-employee-table">
                <CreateTableForReferenceSelect
                  dataList={holidayData?.data ?? []}
                  dataHeader={header}
                  dataAccessor={accessor}
                  setSelectedReference={setSelectedReference}
                  // viewHandleClick={viewHandleClick}
                />
                {holidayData?.data?.length > 0 ? (
                  <div></div>
                ) : (
                  <div> {/*<p>No records to display</p>*/}</div>
                )}
              </div>
            </div>
            <div
              className="buttons row"
              style={{ justifyContent: "end", padding: "50px 20px 0 20px" }}
            >
              <button
                id="add-family"
                className="save row"
                onClick={handleProceed}
              >
                PROCEED
              </button>
            </div>
          </div>
        )}
      </div>
    </>
  );
}
function ReferenceOffsetDateSelectForm({ isOpen, onClose, overtimeData, reference, setReference, setHours, user }) {
  var header = [
    "Date",
    "Time In",
    "Time Out",
  ];
  var accessor = [
    "date",
    "timeIn",
    "timeOut",
  ];

  // const [data, setData] = useState([]);
  const [selectedReference, setSelectedReference] = useState(null);

  const handleClose = () => {
    onClose();
    // fetchData();
  };
  const handleProceed = () => {
    if (selectedReference?.length !== 0) {
      const foundReference = reference.find(i => i.id === selectedReference.id)

      if(foundReference){
        alert("Already added this reference");
      } else 
      {
        setReference((prev) => [...prev, selectedReference]);
        // fetchData();
        onClose();
      }
    }
  };

  return (
    <>
      <div className={`modal-overlay ${isOpen ? "open" : ""}`}>
        {isOpen && (
          <div className="modal">
            <div className="popUp-header row">
              <div className="popUp-title">
                <h3 style={{ color: "#668fca" }}>Select Reference Date</h3>
              </div>
              <div className="popUp-close">
                <CloseIcon onClick={() => handleClose()} />
              </div>
            </div>
            <div className="popUp-body selectModal">
              <div className="select-employee-table">
                <CreateTableForReferenceSelect
                  dataList={overtimeData ?? []}
                  dataHeader={header}
                  dataAccessor={accessor}
                  setSelectedReference={setSelectedReference}
                  // viewHandleClick={viewHandleClick}
                />
                {overtimeData?.data?.length > 0 ? (
                  <div></div>
                ) : (
                  <div> {/*<p>No records to display</p>*/}</div>
                )}
              </div>
            </div>
            <div
              className="buttons row"
              style={{ justifyContent: "end", padding: "50px 20px 0 20px" }}
            >
              <button
                id="add-family"
                className="save row"
                onClick={handleProceed}
              >
                PROCEED
              </button>
            </div>
          </div>
        )}
      </div>
    </>
  );
}
function TypeSelect({ data, setData }) {
  const [isSelected, setIsSelected] = useState(false);

  const handleSelectChange = (event) => {
    setIsSelected(true);
    setData(event.target.value);
  };

  useEffect(() => {
    if (data !== "") {
      setIsSelected(true);
    } else {
      setIsSelected(false);
    }
  }, [data]);

  return (
    <div>
      <select
        id="employee-select-PagibigReport"
        value={data}
        onChange={handleSelectChange}
        style={{
          color: isSelected ? "rgb(104, 104, 104)" : "rgba(0, 0, 0, 0.356)",
        }}
      >
        <option value="" disabled hidden>
          Choose type
        </option>
        <option value="Overtime">Overtime</option>
        <option value="Leave">Leave</option>
        <option value="Holiday">Holiday</option>
      </select>
    </div>
  );
}
function DateTimeInput({ date, setDate }) {
  const [isSelected, setIsSelected] = useState(false);

  const handleDateTimeChange = (event) => {
    setDate(event.target.value);
    setIsSelected(true);
  };

  useEffect(() => {
    if (date !== undefined && date !== "") {
      setIsSelected(true);
    } else {
      setIsSelected(false);
    }
  }, [date]);

  return (
    <div>
      <input
        type="date"
        id={"datetime-"}
        name="datetime"
        value={date.slice(0, 16)} // Exclude milliseconds
        onChange={handleDateTimeChange}
        style={{
          width: "90%",
          height: "30px",
          borderRadius: "3px",
          border: "1px solid #80808080",
          color: isSelected ? "rgb(104, 104, 104)" : "rgba(0, 0, 0, 0.356)",
          fontFamily:
            "'Trebuchet MS', 'Lucida Sans Unicode', 'Lucida Grande', 'Lucida Sans', Arial, sans-serif",
        }}
      />
    </div>
  );
}
function EmployeeSelectForm({ isOpen, onClose, user, setEmployeeId, setEmployee }) {
  var header = ["Id", "Name"];
  var accessor = ["employeeId", "fullName"];

  const handleClose = () => {
    onClose();
    fetchData();
  };
  const handleProceed = () => {
    onClose();
    setEmployeeId(selectedEmployee.id);
    setEmployee(selectedEmployee.fullName);
    fetchData();
  };

  const [currentPage, setCurrentPage] = useState(1);
  const [loading, setLoading] = useState(false);
  const [employees, setEmployees] = useState([]);
  const [selectedEmployee, setSelectedEmployee] = useState([]);
  const [filterData, setFilterData] = useState([]);
  const [filterDataIndex, setFilterDataIndex] = useState(0);
  const [searchPlaceholder, setSearchPlaceholder] = useState("Search by name");

  const fetchData = async () => {
        const apiUrl =  domain + "/api/Employee/basic-info/all/active";

        try {
            setLoading(true);
            const response = await axios.get(apiUrl , {
            headers: {
                'Authorization': `Bearer ${token}`,
                'Content-Type': 'application/json' // You can include other headers if needed
            }})
                setEmployees(response.data); // Set the response data to the state
                setFilterData(response.data); // Set the response data to the state
        } catch (error) {
            console.error('Error fetching data:', error);
        } finally {
            setLoading(false); // Set loading state to false after data fetching is complete
        }
    }
  const handleFilter = (value) => {
    setCurrentPage(1);
    const lowercaseValue = value.toLowerCase();
    var res = [];

    switch (filterDataIndex) {
      case 0:
        res = filterData.filter((f) =>
          f.fullName.toLowerCase().includes(lowercaseValue)
        );
        break;
      case 1:
        res = filterData.filter((f) =>
          f.employeeId.toString().startsWith(lowercaseValue)
        );
        break;
      default:
        res = filterData.filter((f) =>
          f.fullName.toLowerCase().includes(lowercaseValue)
        );

        break;
    }

    setEmployees(res);
  };

  useEffect(() => {
    switch (filterDataIndex) {
      case 0:
        setSearchPlaceholder("Search by name");
        break;
      case 1:
        setSearchPlaceholder("Search by id");
        break;
      default:
        setSearchPlaceholder("Search by name");
        break;
    }
    fetchData();
  }, [filterDataIndex]);

  return (
    <>
      <div className={`modal-overlay ${isOpen ? "open" : ""}`}>
        {isOpen && (
          <div className="modal">
            <div className="popUp-header row">
              <div className="popUp-title">
                <h3 style={{ color: "#668fca" }}>Select Employee</h3>
              </div>
              <div className="popUp-close">
                <CloseIcon onClick={() => handleClose()} />
              </div>
            </div>
            <div className="transaction-body">
              <EmployeeFilter setFilterDataIndex={setFilterDataIndex} />
              <div className="transaction-body-top row">
                {CreateSearchBarWithPlaceHolder(
                  "",
                  "transaction-search row",
                  "transaction-search-icon",
                  "transaction-search-input",
                  (e) => handleFilter(e.target.value),
                  searchPlaceholder,
                  SearchIcon
                )}
              </div>
            </div>
            <div className="popUp-body">
              <div className="select-employee-table">
                <CreateTableForEmployeeSelect
                  dataList={employees}
                  dataHeader={header}
                  dataAccessor={accessor}
                  setSelectedEmployee={setSelectedEmployee}
                  currentPage={currentPage}
                  setCurrentPage={setCurrentPage}
                />
                {employees?.length > 0 ? (
                  <div></div>
                ) : (
                  <div>
                    {loading ? (
                      <div
                        style={{
                          display: "flex",
                          justifyContent: "center",
                          alignItems: "center",
                          height: "10vh",
                        }}
                      >
                        <img src={loadingSpinner} alt="Loading..." />
                      </div>
                    ) : (
                      <div> {/*<p>No records to display</p>*/}</div>
                    )}
                  </div>
                )}
              </div>
            </div>
            <div
              className="buttons row"
              style={{ justifyContent: "end", padding: "50px 20px 0 20px" }}
            >
              <button
                id="add-family"
                className="save row"
                onClick={handleProceed}
              >
                PROCEED
              </button>
            </div>
          </div>
        )}
      </div>
    </>
  );
}
function EmployeeFilter({ setFilterDataIndex }) {
  const [selectedOption, setSelectedOption] = useState("All");

  const handleSelectChange = (event) => {
    setSelectedOption(event.target.value);

    switch (event.target.value) {
      case "All":
        setFilterDataIndex(0);
        break;
      case "EmployeeId":
        setFilterDataIndex(1);
        break;
      default:
        setFilterDataIndex(0);
        break;
    }
  };

  return (
    <div className="filters row" style={{ alignItems: "center" }}>
      <span style={{ marginRight: "10px" }}>Filter</span>
      <select
        id=""
        className="filterSelect"
        value={selectedOption}
        onChange={handleSelectChange}
      >
        <option value="All">All</option>
        <option value="EmployeeId">Employee Id</option>
      </select>
    </div>
  );
}
function ViewHistoryForm({ isOpen, onClose, user }) {
  var header_overtime = [
    "Reference No.",
    "Date",
    "Hours",
    "Reason",
    "Date Requested",
    "Uploaded Image",
    "Status",
    "",
  ];
  var accessor_overtime = [
    "referenceNumber",
    "date",
    "hours",
    "reason",
    "dateRequested",
    "content",
    "status",
    "manage",
  ];

  var header_leave = [
    "Reference No.",
    "Reference Id",
    "Date From",
    "Date To",
    "Days",
    "Reason",
    "Date Requested",
    "Uploaded Image",
    "Status",
    "",
  ];
  var accessor_leave = [
    "referenceNumber",
    "referenceId",
    "dateFrom",
    "dateTo",
    "days",
    "reason",
    "dateRequested",
    "content",
    "status",
    "manage",
  ];

  var header_holiday = [
    "Reference No.",
    "Date",
    "Days",
    "Reason",
    "Date Requested",
    "Uploaded Image",
    "Status",
    "",
  ];
  var accessor_holiday = [
    "referenceNumber",
    "holidayDate",
    "holidayDays",
    "reason",
    "dateRequested",
    "content",
    "status",
    "manage",
  ];

  var header_date = [
    "Reference Date",
    "Time In",
    "Time Out",
    "Date To Use",
    //"",
  ];
  var accessor_date = [
    "referenceDate",
    "timeIn",
    "timeOut",
    "date",
    //"manage",
  ];

  const [viewImageData, setViewImageData] = useState("");
  const [loadingRequest, setLoadingRequest] = useState(false);
  const [showViewImage, setShowViewImage] = useState(false);
  const [selectedTab, setSelectedTab] = useState(0);
  const [currentPage_overtime, setCurrentPage_overtime] = useState(1);
  const [currentPage_leave, setCurrentPage_leave] = useState(1);
  const [currentPage_holiday, setCurrentPage_holiday] = useState(1);

  const [overtimeData, setOvertimeData] = useState([]);
  const [leaveData, setLeaveData] = useState([]);
  const [holidayData, setHolidayData] = useState([]);

  const handleSelectChange = (index) => {
    setCurrentPage_overtime(1);
    setCurrentPage_leave(1);
    setCurrentPage_holiday(1);
    setSelectedTab(index);
  };

  const [loading, setLoading] = useState(false);

  const fetchData = useCallback(async () => {
    setLoading(true);

    const apiUrl =
      domain +
      `/api/OffsetRequest/employee/${
        user.employeePersonalInformationId
      }/days-range/${30}`;

    try {
      const response = await axios.get(apiUrl, {
        headers: {
          Authorization: `Bearer ${token}`,
          "Content-Type": "application/json", // You can include other headers if needed
        },
      });

      const _overtimeData = response.data.filter((i) => i.type === "Overtime");
      const _leaveData = response.data.filter((i) => i.type === "Leave");
      const _holidayData = response.data.filter((i) => i.type === "Holiday");

      setOvertimeData(_overtimeData);
      setLeaveData(_leaveData);
      setHolidayData(_holidayData);
    } catch (error) {
      console.error("Error fetching data:", error);
    }

    setLoading(false);
  }, [user]);

  useEffect(() => {
    if (isOpen) {
      fetchData();
    }
  }, [isOpen, fetchData]);

  const handleClose = () => {
    onClose();
  };

  const [showViewOffsetForm, setShowViewOffsetForm] = useState(false);
  const [
      employeePersonalInformationFullNameOffset,
      setEmployeePersonalInformationFullNameOffset,
  ] = useState("");
  const [
      employeePersonalInformationIdOffset,
      setEmployeePersonalInformationIdOffset,
  ] = useState("");
  const [offset_type, setOffset_type] = useState("");
  const [offset_type_current, setOffset_type_current] = useState("");
  const [offset_references, setOffset_references] = useState([]);
  const [offset_date, setOffset_date] = useState("");
  const [offset_hours, setOffset_hours] = useState(0);
  const [offset_dateFrom, setOffset_dateFrom] = useState("");
  const [offset_dateTo, setOffset_dateTo] = useState("");
  const [offset_days, setOffset_days] = useState(0);
  const [offset_holidayDate, setOffset_holidayDate] = useState("");
  const [offset_holidayDays, setOffset_holidayDays] = useState(0);
  const [offset_reason, setOffset_reason] = useState("");
  const [filesOffset, setFilesOffset] = useState("");

  useEffect(() => {
      if(offset_type !== offset_type_current){
      setOffset_type_current(offset_type)

      setOffset_references([]);
      setOffset_date("");
      setOffset_hours("");
      setOffset_dateFrom("");
      setOffset_dateTo("");
      setOffset_days("");
      setOffset_holidayDate("");
      setOffset_holidayDays(0);
      }
  }, [offset_type, offset_type_current])

  const [deleteData, setDeleteData] = useState([]);
  const [showDeleteForm, setShowDeleteForm] = useState(false);

  const [editData, setEditData] = useState([]);
  const [showEditOffsetForm, setShowEditOffsetForm] = useState(false);
  const offsetRequestTimeApiUrl = domain + "/api/OffsetRequest";

  //Request Messages -start
  const [showRequestMessage, setShowRequestMessage] = useState(false);
  const [requestMessage, setRequestMessage] = useState("");
  const [isSuccess, setIsSuccess] = useState("");
  useEffect(() => {
      if (showRequestMessage) {
          const timeoutId = setTimeout(() => {
              setShowRequestMessage(false);
          }, 5000);

          return () => clearTimeout(timeoutId);
      }
      
  }, [showRequestMessage]);
  function GenerateMessage({form, message, isSuccess}){
      return (
          <>
              <div className={`modal-overlay toggleMessage-overlay ${form ? 'open' : ''}`}>
                  {form && (
                  <div className="modal toggleMessage" style={{backgroundColor: isSuccess ? "#E0FFDC" : "#ffd0c5"}}>
                      <div className='column'>
                          {isSuccess ?
                              <div className='request_title row' style={{fontWeight:"bold", color:"green", alignItems:"center"}}>
                                  <CheckCircleIcon/>
                                  <span >{"SUCCESS MESSAGE"}</span>
                              </div>
                              :
                              <div className='request_title row' style={{fontWeight:"bold", color:"#DD5746", alignItems:"center"}}>
                                  <ErrorIcon/>
                                  <span>{"ERROR MESSAGE"}</span>
                              </div>
                          }
                          <span style={{textAlign:"center", padding:"10px 0", color: isSuccess? "green" : "#DD5746"}}>{message}</span>
                      </div>
                  </div>
              )}
              </div>
          </>
      );
  }
  //Request Messages -end

  const fetchOffsetRequest = useCallback(
      async (data) => {
      setLoadingRequest(true);
      try {
          const response = await axios.get(
          offsetRequestTimeApiUrl + `/${data.id}`,
          {
              headers: {
              Authorization: `Bearer ${token}`,
              "Content-Type": "application/json", // You can include other headers if needed
              },
          }
          );
          return response.data; // Set the response data to the state
      } catch (error) {
          setLoadingRequest(false);
          console.error("Error fetching data:", error);
          return [];
      } finally {
          setLoadingRequest(false);
      }
  }, [offsetRequestTimeApiUrl]);

  const viewHandleClick = async (data) => {
    setShowViewOffsetForm(true);
    const requestDataWithId = await fetchOffsetRequest(data);
    setEmployeePersonalInformationFullNameOffset(
        requestDataWithId.employeePersonalInformationFullName
    );
    setEmployeePersonalInformationIdOffset(
        requestDataWithId.employeePersonalInformationId
    );
    setOffset_type(requestDataWithId.type);
    setOffset_type_current(requestDataWithId.type);
    setOffset_references(requestDataWithId.references);
    setOffset_date(requestDataWithId.date);
    setOffset_hours(requestDataWithId.hours);
    setOffset_dateFrom(requestDataWithId.dateFrom);
    setOffset_dateTo(requestDataWithId.dateTo);
    setOffset_days(requestDataWithId.days);
    setOffset_holidayDate(requestDataWithId.holidayDate);
    setOffset_holidayDays(requestDataWithId.holidayDays);
    setOffset_reason(requestDataWithId.reason);
    let filesToBeSet = [];

    if (requestDataWithId.content) {
        const binaryData = atob(requestDataWithId.content);

        // Convert the binary data to a Uint8Array
        const arrayBuffer = new ArrayBuffer(binaryData.length);
        const uint8Array = new Uint8Array(arrayBuffer);
        for (let i = 0; i < binaryData.length; i++) {
        uint8Array[i] = binaryData.charCodeAt(i);
        }

        const blob = new Blob([uint8Array], { type: "image/jpeg" }); // Adjust the MIME type as per your data

        const file = new File([blob], "filename.jpg", { type: "image/jpeg" }); // Provide a filename and MIME type

        filesToBeSet.push(file);
    }

    setFilesOffset(filesToBeSet);
  };
  const closeViewHandleClick = () => {
    setShowViewOffsetForm(false);
  };

  const [approveMessage, setApproveMessage] = useState(false);
  const [disapproveMessage, setDisapproveMessage] = useState(false);
  const [cancelledMessage, setCancelledMessage] = useState(false);


  const editHandleClick = async (data) => {
      if(data.status === "Approved"){
          setApproveMessage(true);
          return;
      } else if(data.status === "Disapproved"){
          setDisapproveMessage(true);
          return;
      } else if(data.status === "Cancelled"){
          setCancelledMessage(true);
          return;
      }
      
      setShowEditOffsetForm(true);
      const requestDataWithId = await fetchOffsetRequest(data);
      setEditData(requestDataWithId);
      setEmployeePersonalInformationFullNameOffset(
          requestDataWithId.employeePersonalInformationFullName
      );
      setEmployeePersonalInformationIdOffset(
          requestDataWithId.employeePersonalInformationId
      );

      setOffset_type(requestDataWithId.type);
      setOffset_type_current(requestDataWithId.type);
      setOffset_references(requestDataWithId.references);
      setOffset_date(requestDataWithId.date);
      setOffset_hours(requestDataWithId.hours);
      setOffset_dateFrom(requestDataWithId.dateFrom);
      setOffset_dateTo(requestDataWithId.dateTo);
      setOffset_days(requestDataWithId.days);
      setOffset_holidayDate(requestDataWithId.holidayDate);
      setOffset_holidayDays(requestDataWithId.holidayDays);
      setOffset_reason(requestDataWithId.reason);

      let filesToBeSet = [];

      if (requestDataWithId.content) {
          const binaryData = atob(requestDataWithId.content);

          // Convert the binary data to a Uint8Array
          const arrayBuffer = new ArrayBuffer(binaryData.length);
          const uint8Array = new Uint8Array(arrayBuffer);
          for (let i = 0; i < binaryData.length; i++) {
          uint8Array[i] = binaryData.charCodeAt(i);
          }

          const blob = new Blob([uint8Array], { type: "image/jpeg" }); // Adjust the MIME type as per your data

          const file = new File([blob], "filename.jpg", { type: "image/jpeg" }); // Provide a filename and MIME type

          filesToBeSet.push(file);
      }

      setFilesOffset(filesToBeSet);
  };

  const closeEditHandleClick = () => {
    setShowEditOffsetForm(false);

    setEditData(null)
  };
  const updateRequest = async (event) => {
      event.preventDefault();
      setLoadingRequest(true);

      const offsetRequestTimeApiUrl = domain + "/api/OffsetRequest";

      let data = {};

      var requestUrl = offsetRequestTimeApiUrl;

      if(offset_references.length <= 0){
          setLoadingRequest(false);
          setShowRequestMessage(true);
          setIsSuccess(false);
          setRequestMessage("You need at least 1 reference.");
          return
      }

      const toBase64 = (file) =>
          new Promise((resolve, reject) => {
          const reader = new FileReader();
          reader.readAsDataURL(file);
          reader.onload = () => resolve(reader.result);
          reader.onerror = (error) => reject(error);
          });

      let base64String = "";
      let photoToBeSave = "";

      if (filesOffset.length > 0) {
          base64String = await toBase64(filesOffset[0]);
          photoToBeSave = base64String.split(",")[1];
      }

      const uploadImage = filesOffset ? photoToBeSave : null;

      data = {
          referenceNumber: editData.referenceNumber,
          employeePersonalInformationId: user.employeePersonalInformationId, //temporary
          approverId: editData.approverId,
          requestTypeId: editData.requestTypeId,
          reason: offset_reason,
          reasonForRejection: editData.reasonForRejection,
          status: editData.status,
          dateRequested: editData.dateRequested,
          dateCompleted: editData.dateCompleted,
          content: uploadImage,
          references: offset_references,
          date: offset_date ? offset_date : null,
          totalHours: offset_hours ? offset_hours : 0,
          type: offset_type,
          dateFrom: offset_dateFrom ? offset_dateFrom : null,
          dateTo: offset_dateTo ? offset_dateTo : null,
          totalDays: offset_days ? offset_days : null,
          holidayDate: offset_holidayDate ? offset_holidayDate : null,
          holidayDays: offset_holidayDays ? offset_holidayDays : null,
      };

      try {
          await axios.put(requestUrl + `/${editData.id}`, data, {
              headers: {
                  'Authorization': `Bearer ${token}`,
                  'Content-Type': 'application/json'
              }
          });
          console.log('Data updated successfully');
          
          closeEditHandleClick();

          // Reload table data and reset form fields
          await fetchData(); // Assuming fetchData() fetches the updated data for the table
          setEditData([]);

          setShowRequestMessage(true);
          setIsSuccess(true);
          setRequestMessage("Request Successful");
      } catch (error) {
          console.error('There was a problem updating data:', error);
          setLoadingRequest(false);
          setShowRequestMessage(true);
          setIsSuccess(false);
          console.error('Error:', error);
          const errorMessage = JSON.parse(error.response.request.responseText).message;
          setRequestMessage(errorMessage);
      } finally {
          setLoadingRequest(false);
      }
  }

  const deleteHandleClick = (data) => {
      /* if(data.status === "Approved"){
          setApproveMessage(true);
          return;
      } else if(data.status === "Disapproved"){
          setDisapproveMessage(true);
          return;
      } else */ if(data.status === "Cancelled"){
          setCancelledMessage(true);
          return;
      }

      setDeleteData(data);
      setShowDeleteForm(true);
  }
  const closeDeleteHandleClick = () => {
      setShowDeleteForm(false);
  };
  const cancelRequest = async (event) => {
      event.preventDefault();
      setLoadingRequest(true);

      const offsetRequestTimeApiUrl = domain + "/api/OffsetRequest";

      var requestUrl = offsetRequestTimeApiUrl;

      const data = {
          id: deleteData.id,
          approverId: user.id, //temporary
          status: "Cancelled",
          reasonForRejection: ""
      };

      try {
          await axios.put(requestUrl + "/status", data, {
              headers: {
                  'Authorization': `Bearer ${token}`,
                  'Content-Type': 'application/json'
              }
          });
          console.log('Data updated successfully');

          setShowDeleteForm(false);

          // Reload table data and reset form fields
          await fetchData(); // Assuming fetchData() fetches the updated data for the table
          setDeleteData([]);

          setShowRequestMessage(true);
          setIsSuccess(true);
          setRequestMessage("Request Successful");
      } catch (error) {
          console.error('There was a problem updating data:', error);
          setLoadingRequest(false);
          setShowRequestMessage(true);
          setIsSuccess(false);
          console.error('Error:', error);
          const errorMessage = JSON.parse(error.response.request.responseText).message;
          setRequestMessage(errorMessage);
      } finally {
          setLoadingRequest(false);
      }
  }

  const viewImage = (data) => {
      setViewImageData(data);
      setShowViewImage(true);
  }
  const closeViewImage = () => {
      setShowViewImage(false);
  }

  useEffect(() => {
      if (approveMessage) {
          const timeoutId = setTimeout(() => {
              setApproveMessage(false);
          }, 5000);
  
          return () => clearTimeout(timeoutId);
      }
  }, [approveMessage]);
  useEffect(() => {
      if (disapproveMessage) {
          const timeoutId = setTimeout(() => {
              setDisapproveMessage(false);
          }, 5000);
  
          return () => clearTimeout(timeoutId);
      }
  }, [disapproveMessage]);
  useEffect(() => {
      if (cancelledMessage) {
          const timeoutId = setTimeout(() => {
              setCancelledMessage(false);
          }, 5000);
  
          return () => clearTimeout(timeoutId);
      }
  }, [cancelledMessage]);

  return (
    <>
      <div className={`modal-overlay ${isOpen ? "open" : ""}`}>
        {isOpen && (
          <div className="modal">
            <div className="popUp-header row">
              <div className="popUp-title">
                <h3 style={{ color: "#668fca" }}>Offset Filed History</h3>
              </div>
              <div className="popUp-close">
                <CloseIcon onClick={() => handleClose()} />
              </div>
            </div>
            <div className="popUp-body loan-history-table user-template-body">
              <div
                className="users-table container loan-tab hidden"
                style={{ overflow: "unset" }}
              >
                <Tabs
                  selectedIndex={selectedTab}
                  onSelect={(index) => handleSelectChange(index)}
                >
                  <TabList>
                    <Tab>
                      <b>OVERTIME</b>
                    </Tab>
                    <Tab>
                      <b>LEAVE</b>
                    </Tab>
                    <Tab>
                      <b>HOLIDAY</b>
                    </Tab>
                  </TabList>
                  <TabPanel>
                    <div className="transaction-table container">
                      {/* <CreateTable
                        dataList={overtimeData ?? []}
                        dataHeader={header_overtime}
                        dataAccessor={accessor_overtime}
                        // editHandleClick={editHandleClick}
                        currentPage={currentPage_overtime}
                        setCurrentPage={setCurrentPage_overtime}
                      /> */}
                      <CreateTableTransaction
                          dataList={overtimeData ?? []}
                          dataHeader={header_overtime}
                          dataAccessor={accessor_overtime}
                          viewHandleClick={viewHandleClick}
                          editHandleClick={editHandleClick}
                          deleteHandleClick={deleteHandleClick}
                          viewImage={viewImage}
                          
                          currentPage={currentPage_overtime}
                          setCurrentPage={setCurrentPage_overtime}
                      />
                    </div>
                  </TabPanel>
                  <TabPanel>
                    <div className="transaction-table container">
                      {/* <CreateTable
                        dataList={leaveData ?? []}
                        dataHeader={header_leave}
                        dataAccessor={accessor_leave}
                        // editHandleClick={editHandleClickBeneficiary}
                        // deleteHandleClick={deleteHandleClick}
                        currentPage={currentPage_leave}
                        setCurrentPage={setCurrentPage_leave}
                      /> */}
                      <CreateTableTransaction
                        dataList={leaveData ?? []}
                        dataHeader={header_leave}
                        dataAccessor={accessor_leave}
                        viewHandleClick={viewHandleClick}
                        editHandleClick={editHandleClick}
                        deleteHandleClick={deleteHandleClick}
                        viewImage={viewImage}
                          
                        currentPage={currentPage_leave}
                        setCurrentPage={setCurrentPage_leave}
                      />
                    </div>
                  </TabPanel>
                  <TabPanel>
                    <div className="transaction-table container">
                      {/* <CreateTable
                        dataList={holidayData ?? []}
                        dataHeader={header_holiday}
                        dataAccessor={accessor_holiday}
                        // editHandleClick={editHandleClickBeneficiary}
                        // deleteHandleClick={deleteHandleClick}
                        currentPage={currentPage_holiday}
                        setCurrentPage={setCurrentPage_holiday}
                      /> */}
                      <CreateTableTransaction
                        dataList={holidayData ?? []}
                        dataHeader={header_holiday}
                        dataAccessor={accessor_holiday}
                        viewHandleClick={viewHandleClick}
                        editHandleClick={editHandleClick}
                        deleteHandleClick={deleteHandleClick}
                        viewImage={viewImage}
                          
                        currentPage={currentPage_holiday}
                        setCurrentPage={setCurrentPage_holiday}
                      />
                    </div>
                  </TabPanel>
                </Tabs>
              </div>


              <div className="transaction-table container">
                <CreateTableTransaction
                    dataList={overtimeData ?? []}
                    dataHeader={header_date}
                    dataAccessor={accessor_date}
                    viewHandleClick={viewHandleClick}
                    editHandleClick={editHandleClick}
                    deleteHandleClick={deleteHandleClick}
                    viewImage={viewImage}
                    
                    currentPage={currentPage_overtime}
                    setCurrentPage={setCurrentPage_overtime}
                />
              </div>
            </div>
            <div
              className="buttons row"
              style={{
                justifyContent: "center",
                padding: "40px 40px 20px 40px",
              }}
            ></div>
          </div>
        )}
      </div>
      {loadingRequest || loading ? (
        <div
          style={{
            position: "fixed",
            top: "0",
            left: "0",
            width: "100vw",
            height: "100vh",
            zIndex: "10000",
            display: "flex",
            flexDirection: "column",
            alignItems: "center",
            justifyContent: "center",
            textAlign: "center",
            backgroundColor: "#ffffff59",
          }}
        >
          <img src={loadingSpinner} alt="Loading..." />
        </div>
      ) : (
        <></>
      )}
      <ViewOffsetForm
          isOpen={showViewOffsetForm}
          onClose={closeViewHandleClick}
          employeePersonalInformationFullName={ employeePersonalInformationFullNameOffset } setEmployeePersonalInformationFullName={ setEmployeePersonalInformationFullNameOffset }
          employeePersonalInformationId={employeePersonalInformationIdOffset} setEmployeePersonalInformationId={setEmployeePersonalInformationIdOffset}
          references={offset_references} setReferences={setOffset_references}
          date={offset_date} setDate={setOffset_date}
          hours={offset_hours} setHours={setOffset_hours}
          type={offset_type} setType={setOffset_type}
          dateFrom={offset_dateFrom} setDateFrom={setOffset_dateFrom}
          dateTo={offset_dateTo} setDateTo={setOffset_dateTo}
          days={offset_days} setDays={setOffset_days}
          holidayDate={offset_holidayDate} setHolidayDate={setOffset_holidayDate}
          holidayDays={offset_holidayDays} setHolidayDays={setOffset_holidayDays}
          reason={offset_reason} setReason={setOffset_reason}
          files={filesOffset} setFiles={setFilesOffset}
          viewImage={viewImage}
      ></ViewOffsetForm>
      <EditOffsetForm
          user={user}
          isOpen={showEditOffsetForm}
          onClose={closeEditHandleClick}
          employeePersonalInformationFullName={ employeePersonalInformationFullNameOffset } setEmployeePersonalInformationFullName={ setEmployeePersonalInformationFullNameOffset }
          employeePersonalInformationId={employeePersonalInformationIdOffset} setEmployeePersonalInformationId={setEmployeePersonalInformationIdOffset}
          references={offset_references} setReferences={setOffset_references}
          date={offset_date} setDate={setOffset_date}
          hours={offset_hours} setHours={setOffset_hours}
          type={offset_type} setType={setOffset_type}
          dateFrom={offset_dateFrom} setDateFrom={setOffset_dateFrom}
          dateTo={offset_dateTo} setDateTo={setOffset_dateTo}
          days={offset_days} setDays={setOffset_days}
          holidayDate={offset_holidayDate} setHolidayDate={setOffset_holidayDate}
          holidayDays={offset_holidayDays} setHolidayDays={setOffset_holidayDays}
          reason={offset_reason} setReason={setOffset_reason}
          files={filesOffset} setFiles={setFilesOffset}
          editData={editData}
          handleUpdate={updateRequest}
          viewImage={viewImage}
      ></EditOffsetForm>
      <ClearGeneralForm isOpen={showDeleteForm} onClose={closeDeleteHandleClick} handleDelete={cancelRequest}/>
      <ViewImage isOpen={showViewImage}
                  onClose={closeViewImage}
                  viewImageData={viewImageData}
                  >                
      </ViewImage>
      <GenerateMessage form={showRequestMessage}
              message={isSuccess ? "Request Success!" : requestMessage}
              isSuccess={isSuccess}
      > 
      </GenerateMessage>
      <GenerateMessage form={approveMessage}
              message={"Already approved!"}
              isSuccess={false}
      > 
      </GenerateMessage>
      <GenerateMessage form={disapproveMessage}
              message={"Already disapproved!"}
              isSuccess={false}
      > 
      </GenerateMessage>
      <GenerateMessage form={cancelledMessage}
              message={"Already cancelled!"}
              isSuccess={false}
      > 
      </GenerateMessage>
    </>
  );
}
export function CreateTable({
  dataList = [],
  dataHeader = [],
  dataAccessor = [],
  editHandleClick,
  deleteHandleClick,
}) {
  const [currentPage, setCurrentPage] = useState(1);
  const itemsPerPage = 10;

  const columns = React.useMemo(
    () =>
      dataHeader.map((header, index) => ({
        Header: header,
        accessor: dataAccessor[index],
      })),
    [dataHeader, dataAccessor]
  );

  const { getTableProps, getTableBodyProps, headerGroups, rows, prepareRow } =
    useTable({ columns, data: dataList });

  const indexOfFirstItem = (currentPage - 1) * itemsPerPage;
  const indexOfLastItem = Math.min(currentPage * itemsPerPage, rows?.length);
  const currentItems = rows.slice(indexOfFirstItem, indexOfLastItem);

  const totalPages = Math.ceil(rows?.length / itemsPerPage);
  const isLastPage = currentPage === totalPages;

  const paginate = (pageNumber) => {
    if (pageNumber >= 1 && pageNumber <= totalPages) {
      setCurrentPage(pageNumber);
    }
  };

  return (
    <>
      <table {...getTableProps()}>
        <thead>
          {headerGroups.map((headerGroup) => (
            <tr {...headerGroup.getHeaderGroupProps()}>
              {headerGroup.headers.map((column) => (
                <th {...column.getHeaderProps()}>{column.render("Header")}</th>
              ))}
            </tr>
          ))}
        </thead>
        <tbody {...getTableBodyProps()}>
          {dataList?.length <= 0 && (
            <tr>
              <td colSpan={columns?.length} style={{ textAlign: "center" }}>
                No data to display
              </td>
            </tr>
          )}
          {currentItems.map((row) => {
            prepareRow(row);
            return (
              <tr key={row.original.id} {...row.getRowProps()}>
                {row.cells.map((cell) =>
                  SetInfo(
                    cell.render("Cell").props.column.Header,
                    cell,
                    editHandleClick,
                    deleteHandleClick
                  )
                )}
              </tr>
            );
          })}
        </tbody>
      </table>
      {rows?.length > itemsPerPage ? (
        <>
          <div
            className="table-page row"
            style={{
              alignItems: "center",
              justifyContent: "end",
              padding: "20px 0 0 0",
            }}
          >
            <button
              className="prev row"
              onClick={() => paginate(1)}
              disabled={currentPage === 1}
              style={{
                visibility: currentPage === 1 ? "hidden" : "visible",
                marginRight: "5px",
                height: "26px",
              }}
            >
              &lt;&lt;
            </button>
            <button
              className="prev row"
              onClick={() => paginate(currentPage - 1)}
              disabled={currentPage === 1}
              style={{
                visibility: currentPage === 1 ? "hidden" : "visible",
                marginRight: "5px",
                height: "26px",
              }}
            >
              <NavigateBeforeIcon style={{ marginRight: "5px" }} /> PREVIOUS
            </button>
            <button
              className="next row"
              onClick={() => paginate(currentPage + 1)}
              disabled={indexOfLastItem >= rows?.length}
              style={{
                visibility:
                  rows?.length > itemsPerPage && !isLastPage
                    ? "visible"
                    : "hidden",
                marginRight: "5px",
                height: "26px",
              }}
            >
              NEXT <NavigateNextIcon style={{ marginLeft: "5px" }} />
            </button>
            <button
              className="next row"
              onClick={() => paginate(totalPages)}
              disabled={indexOfLastItem >= rows?.length}
              style={{
                visibility:
                  rows?.length > itemsPerPage && !isLastPage
                    ? "visible"
                    : "hidden",
                height: "26px",
              }}
            >
              &gt;&gt;
            </button>
          </div>
          {`${currentPage}/${totalPages}`}
        </>
      ) : (
        <></>
      )}
    </>
  );
}
export function CreateTableForReferenceSelect({
  dataList = [],
  dataHeader = [],
  dataAccessor = [],
  viewHandleClick,
  setSelectedReference,
}) {
  const [currentPage, setCurrentPage] = useState(1);
  const [activeRowId, setActiveRowId] = useState(null);
  const itemsPerPage = 10;

  const columns = React.useMemo(
    () =>
      dataHeader.map((header, index) => ({
        Header: header,
        accessor: dataAccessor[index],
      })),
    [dataHeader, dataAccessor]
  );

  const { getTableProps, getTableBodyProps, headerGroups, rows, prepareRow } =
    useTable({ columns, data: dataList });

  const indexOfFirstItem = (currentPage - 1) * itemsPerPage;
  const indexOfLastItem = Math.min(currentPage * itemsPerPage, rows?.length);
  const currentItems = rows.slice(indexOfFirstItem, indexOfLastItem);

  const totalPages = Math.ceil(rows?.length / itemsPerPage);
  const isLastPage = currentPage === totalPages;

  const paginate = (pageNumber) => {
    if (pageNumber >= 1 && pageNumber <= totalPages) {
      setCurrentPage(pageNumber);
    }
  };

  const handleRowClick = (rowData) => {
    setSelectedReference(rowData); // Pass the clicked row data to the setSelectedEmployee function
    setActiveRowId(rowData.id);
  };

  return (
    <div>
      <table {...getTableProps()}>
        <thead>
          {headerGroups.map((headerGroup) => (
            <tr {...headerGroup.getHeaderGroupProps()}>
              {headerGroup.headers.map((column) => (
                <th {...column.getHeaderProps()}>{column.render("Header")}</th>
              ))}
            </tr>
          ))}
        </thead>
        <tbody {...getTableBodyProps()}>
          {dataList?.length <= 0 && (
            <tr>
              <td colSpan={columns?.length} style={{ textAlign: "center" }}>
                No data to display
              </td>
            </tr>
          )}
          {currentItems.map((row) => {
            prepareRow(row);
            return (
              <tr
                key={row.original.id}
                {...row.getRowProps()}
                onClick={() => handleRowClick(row.original)} // Attach onClick event handler to the row
                className={row.original.id === activeRowId ? "active" : ""}
              >
                {row.cells.map((cell) =>
                  SetInfo(
                    cell.render("Cell").props.column.Header,
                    cell,
                    viewHandleClick
                  )
                )}
              </tr>
            );
          })}
        </tbody>
      </table>
      {rows?.length > itemsPerPage ? (
        <div>
          <div
            className="table-page row"
            style={{
              alignItems: "center",
              justifyContent: "end",
              padding: "20px 0 0 0",
            }}
          >
            <button
              className="prev row"
              onClick={() => paginate(1)}
              disabled={currentPage === 1}
              style={{
                visibility: currentPage === 1 ? "hidden" : "visible",
                marginRight: "5px",
                height: "26px",
              }}
            >
              &lt;&lt;
            </button>
            <button
              className="prev row"
              onClick={() => paginate(currentPage - 1)}
              disabled={currentPage === 1}
              style={{
                visibility: currentPage === 1 ? "hidden" : "visible",
                marginRight: "5px",
                height: "26px",
              }}
            >
              <NavigateBeforeIcon style={{ marginRight: "5px" }} /> PREVIOUS
            </button>
            <button
              className="next row"
              onClick={() => paginate(currentPage + 1)}
              disabled={indexOfLastItem >= rows?.length}
              style={{
                visibility:
                  rows?.length > itemsPerPage && !isLastPage
                    ? "visible"
                    : "hidden",
                marginRight: "5px",
                height: "26px",
              }}
            >
              NEXT <NavigateNextIcon style={{ marginLeft: "5px" }} />
            </button>
            <button
              className="next row"
              onClick={() => paginate(totalPages)}
              disabled={indexOfLastItem >= rows?.length}
              style={{
                visibility:
                  rows?.length > itemsPerPage && !isLastPage
                    ? "visible"
                    : "hidden",
                height: "26px",
              }}
            >
              &gt;&gt;
            </button>
          </div>
          <div
            style={{ textAlign: "center" }}
          >{`${currentPage}/${totalPages}`}</div>
        </div>
      ) : (
        <></>
      )}
    </div>
  );
}
function SetInfo(header, _cell, editHandleClick, deleteHandleClick) {
  const data = _cell.render("Cell").props.row.original;
  const value = _cell.render("Cell").props.value;

  if (header === "") {
    return (
      <td>
        <div
          className="row"
          style={{ alignItems: "center", justifyContent: "center" }}
        >
          <Tooltip text="Update">
            <div
              style={{ padding: "0 5px" }}
              onClick={() => editHandleClick(data)}
            >
              <ModeEditIcon />
            </div>
          </Tooltip>
          {deleteHandleClick ? (
            <Tooltip text="Delete">
              <div
                style={{ padding: "0 5px" }}
                onClick={() => deleteHandleClick(data)}
              >
                <DeleteForeverIcon />
              </div>
            </Tooltip>
          ) : (
            <></>
          )}
        </div>
      </td>
    );
  }

  if (header === "Uploaded Image") {
    if (data.content) {
      const imageSrc = "data:image/jpeg;base64," + data.content;

      return (
        <td>
          <img
            className=""
            src={imageSrc}
            alt=""
            style={{ width: "250px", height: "auto" }}
          />
        </td>
      );
    }
    return (
      <td>
        <img className="" src="" alt="" />
      </td>
    );
  }

  if (header === "Reference No.") {
    const formattedNumber = value?.toString().padStart(6, "0");

    return <td>OS-{formattedNumber}</td>;
  }

  if (header === "Leave Ref No.") {
    const formattedNumber = value?.toString().padStart(6, "0");

    return <td>LV-{formattedNumber}</td>;
  }

  if (header === "Approved?") {
    return (
      <td>
        <input
          type="checkbox"
          id="overtime-allowance"
          className="checkbox"
          name=""
          checked={data.isApproved}
          disabled={true}
        />
      </td>
    );
  }

  if (header === "Has Allowance" || header === "Is Above 2 Hours") {
    return <td>{value.toString()}</td>;
  }

  if (
    header === "Time From" ||
    header === "Time To" ||
    header === "Time In" ||
    header === "Time Out"
  ) {
    const time = _cell.render("Cell").props.value;
    if (!time) {
      return <td>-</td>;
    }

    let timeParts;
    let formattedTime;

    if (globalTimeFormat === "Standard Time") {
      const timeSplit = time.split("T");
      if (timeSplit?.length > 1) {
        timeParts = timeSplit[1].substr(0, 5).split(":");
      } else {
        timeParts = [];
      }
      let hours = parseInt(timeParts[0], 10);
      const minutes = timeParts[1];

      // Convert 24-hour format to 12-hour format and determine AM or PM
      const amPm = hours >= 12 ? "PM" : "AM";
      hours = hours % 12 || 12; // Convert 0 to 12 for 12-hour format

      formattedTime = `${hours}:${minutes} ${amPm}`;
    } else if (globalTimeFormat === "Military Time") {
      const timeSplit = time.split("T");
      if (timeSplit?.length > 1) {
        timeParts = timeSplit[1].substr(0, 5).split(":");
      } else {
        timeParts = [];
      }
      let hours = parseInt(timeParts[0], 10);
      const minutes = timeParts[1];

      formattedTime = `${hours}:${minutes}`;
    }

    return <td>{formattedTime}</td>;
  }

  if (
    header === "Date" ||
    header === "Date From" ||
    header === "Date To" ||
    header === "Date Processed" ||
    header === "Request Date" ||
    header === "Date Requested"
  ) {
    const date = new Date(_cell.render("Cell").props.value);
    if (!date) {
      return <td>-</td>;
    }

    const mm = date.getMonth() + 1; // Adding 1 because getMonth returns 0-indexed months
    const dd = date.getDate();
    const yyyy = date.getFullYear();

    const formattedDateFrom = `${mm}/${dd}/${yyyy}`;

    return <td>{formattedDateFrom}</td>;
  }

  //Double type data
  if (
    header === "Over Percentage" ||
    header === "Deduction" ||
    header === "Salary" ||
    header === "Employee" ||
    header === "Employer" ||
    header === "Range From" ||
    header === "Range To" ||
    header === "Monthly Salary" ||
    header === "SSS ER" ||
    header === "SSS EE" ||
    header === "SSS Total" ||
    header === "ECER" ||
    header === "Total Contribution ER" ||
    header === "Total Contribution EE" ||
    header === "Total Contribution Total" ||
    header === "SE Total Contribution" ||
    header === "Salary Range From" ||
    header === "Salary Range To" ||
    header === "Total Monthly Premium" ||
    header === "Percentage" ||
    header === "Amount" ||
    header === "Total Loan" ||
    header === "Total Balance" ||
    header === "Default Deduction" ||
    header === "Allowance" ||
    header === "Daily Salary" ||
    header === "Allowance" ||
    header === "Total Basic" ||
    header === "Rate" ||
    header === "Hours OT Regular" ||
    header === "Total OT Regular" ||
    header === "Hours OT Exceeded" ||
    header === "Total OT Exceeded" ||
    header === "Hours OT Restday" ||
    header === "Total OT Restday" ||
    header === "Hours Holiday Special" ||
    header === "Total Holiday Special" ||
    header === "Hours Holiday Regular" ||
    header === "Total Holiday Regular" ||
    header === "Hours Restday Holiday Special" ||
    header === "Total Restday Holiday Special" ||
    header === "Hours Restday Holiday Regular" ||
    header === "Total Restday Holiday Regular" ||
    header === "Additions" ||
    header === "SSS" ||
    header === "Pagibig" ||
    header === "Philhealth" ||
    header === "SSS Loan" ||
    header === "SSS Calamity Loan" ||
    header === "Pagibig Loan" ||
    header === "Pagibig Calamity Loan" ||
    header === "Tax" ||
    header === "Deductions" ||
    header === "Adjustments" ||
    header === "Total Net Pay" ||
    header === "Days Absent" ||
    header === "Absent/s" ||
    header === "Days Leave" ||
    header === "Leave/s" ||
    header === "Hours Exceeded" ||
    header === "Total Exceeded" ||
    header === "Hours Undertime" ||
    header === "Undertime" ||
    header === "Hours Late" ||
    header === "Late" ||
    header === "Night Diff" ||
    header === "OT Regular" ||
    header === "OT Restday" ||
    header === "Holiday Special" ||
    header === "Holiday Regular" ||
    header === "Restday Holiday Special" ||
    header === "Restday Holiday Regular" ||
    header === "Total Absents" ||
    header === "Total Late" ||
    header === "Total Undertime" ||
    header === "Total Leaves" ||
    header === "Total Night Diff" ||
    header === "Total Exceed" ||
    header === "Used" ||
    header === "Remaining" ||
    header === "Days" ||
    header === "Exceed"
  ) {
    const value = _cell.render("Cell").props.value;

    if (!value) {
      return <td>0.00</td>;
    }

    // Check if value is a number
    const isNumber = typeof value === "number";

    const numberWithCommasAndDecimal = (number) => {
      return number.toLocaleString("en-US", {
        minimumFractionDigits: 2,
        maximumFractionDigits: 2,
      });
    };

    if (!isNumber) {
      return <td {..._cell.getCellProps()}> {_cell.render("Cell")}</td>;
    }

    const formattedNumber = numberWithCommasAndDecimal(value);

    return <td>{formattedNumber}</td>;
  }

  return <td {..._cell.getCellProps()}> {_cell.render("Cell")}</td>;
}
const Tooltip = ({ text, children }) => {
  const [show, setShow] = useState(false);

  const handleMouseEnter = () => {
    setShow(true);
  };

  const handleMouseLeave = () => {
    setShow(false);
  };

  return (
    <div style={{ position: "relative", display: "inline-block", zIndex: "1" }}>
      <div onMouseEnter={handleMouseEnter} onMouseLeave={handleMouseLeave}>
        {children}
      </div>
      {show && (
        <div
          style={{
            position: "absolute",
            top: "50%",
            left: "-50%",
            transform: "translateX(-50%)",
            backgroundColor: "white",
            color: "gray",
            padding: "5px",
            borderRadius: "5px",
            pointerEvents: "none",
            boxShadow:
              "0 4px 8px 0 rgba(0, 0, 0, 0.2), 0 6px 20px 0 rgba(0, 0, 0, 0.19)",
          }}
        >
          {text}
        </div>
      )}
    </div>
  );
};
function ViewOffsetForm({
    isOpen,
    onClose,
    employeePersonalInformationFullName, setEmployeePersonalInformationFullName,
    employeePersonalInformationId, setEmployeePersonalInformationId,
    references, setReferences,
    date, setDate,
    hours, setHours,
    type, setType,
    dateFrom, setDateFrom,
    dateTo, setDateTo,
    days, setDays,
    holidayDate, setHolidayDate,
    holidayDays, setHolidayDays,
    reason, setReason,
    files, setFiles,
    viewImage,
}) {
    const handleClose = () => {
        onClose();
    };

    return (
        <>
        <div className={`modal-overlay ${isOpen ? "open" : ""}`}>
            {isOpen && (
            <div className="modal">
                <div className="popUp-header row">
                <div className="popUp-title">
                    <h3 style={{ color: "#668fca" }}>Request Details</h3>
                </div>
                <div className="popUp-close">
                    <CloseIcon onClick={() => handleClose()} />
                </div>
                </div>
                <div className="popUp-body">
                <div className="popUp-item info-item column">
                    <div className="info-item-label">Employee</div>
                    <div className="info-item-input">
                    <input
                        readOnly={true}
                        id="employeePersonalInformationFullName"
                        placeholder="Employee"
                        value={employeePersonalInformationFullName}
                        onChange={(e) =>
                        setEmployeePersonalInformationFullName(e.target.value)
                        }
                        style={{ cursor: "not-allowed" }}
                    />
                    </div>
                </div>
                <div className="info-item-holder row">
                    <div className="popUp-item info-item column">
                    <div className="info-item-label">Employee Id</div>
                    <div className="info-item-input">
                        <input
                        readOnly={true}
                        type="number"
                        id="employeePersonalInformationId"
                        placeholder="Employee Id"
                        value={employeePersonalInformationId}
                        onChange={(e) =>
                            setEmployeePersonalInformationId(e.target.value)
                        }
                        style={{ cursor: "not-allowed" }}
                        />
                    </div>
                    </div>
                </div>
                <div className="popUp-item info-item column">
                    <div className="info-item-label">Type</div>
                    <div className="info-item-input">
                    <TypeSelect data={type} setData={setType} isView={true}/>
                    </div>
                </div>
                {type === "Overtime" &&
                <>
                    <div className="info-item-holder row">
                    <div className="popUp-item info-item column">
                        <div className="info-item-label">References</div>
                        <div className="info-item-input">
                            {references.map((item) => {
                                console.log({item})
                                return (
                                <div key={item.id} className="flex flex-row gap-5">
                                    <span>{item?.offsetOvertime?.date ? `Date: ${item?.offsetOvertime?.date?.split("T")[0]}` : ""}</span>
                                    <span>{item?.offsetOvertime?.hours ? `Hours: ${item?.offsetOvertime?.hours}` : ""}</span>
                                </div>
                            );
                            })}
                        </div>
                    </div>
                    </div>
                    
                    <div className="info-item-holder row">
                    <div className="popUp-item info-item column">
                        <div className="info-item-label">Date (To Use)</div>
                        <div className="info-item-input">
                        <DateInput2 date={date} setDate={setDate} isView={false}/>
                        </div>
                    </div>
                    <div className="popUp-item info-item column">
                        <div className="info-item-label">Hours</div>
                        <div className="info-item-input">
                        <input
                            type="number"
                            id="hours"
                            placeholder="Hours"
                            value={hours}
                            readOnly={true}
                        />
                        </div>
                    </div>
                    </div>
                </>
                }
                {type === "Leave" &&
                <>
                    <div className="info-item-holder row">
                    <div className="popUp-item info-item column">
                        <div className="info-item-label">References</div>
                        <div className="info-item-input">
                            {references.map((item) => {
                                return (
                                <div key={item.id} className="flex flex-row gap-5">
                                    <span>{item?.offsetLeave?.leaveId ? `Reference Number: LV-${item?.offsetLeave?.leaveId?.toString()?.padStart(6, "0")}` : ""}</span>
                                    <span>{item?.offsetLeave?.days ? `Days: ${item?.offsetLeave?.days}` : ""}</span>
                                </div>
                            );
                            })}
                        </div>
                    </div>
                    </div>
                    <div className="info-item-holder row">
                    <div className="popUp-item info-item column">
                        <div className="info-item-label">Date From (To Use)</div>
                        <div className="info-item-input">
                        <DateInput2 date={dateFrom} setDate={setDateFrom} isView={true} />
                        </div>
                    </div>
                    <div className="popUp-item info-item column">
                        <div className="info-item-label">Date To (To Use)</div>
                        <div className="info-item-input">
                        <DateInput2 date={dateTo} setDate={setDateTo} isView={true} />
                        </div>
                    </div>
                    </div>
                </>
                }
                {type === "Holiday" &&
                <>
                    <div className="info-item-holder row">
                    <div className="popUp-item info-item column">
                        <div className="info-item-label">References</div>
                        <div className="info-item-input">
                            {references.map((item) => {
                                return (
                                <div key={item.id} className="flex flex-row gap-5">
                                    <span>{item?.offsetHoliday?.date ? `Date: ${item?.offsetHoliday?.date?.split("T")[0]}` : ""}</span>
                                    <span>{item?.offsetHoliday?.days ? `Days: ${item?.offsetHoliday?.days}` : ""}</span>
                                </div>
                            );
                            })}
                        </div>
                    </div>
                    </div>
                    
                    <div className="info-item-holder row">
                    <div className="popUp-item info-item column">
                        <div className="info-item-label">Date (To Use)</div>
                        <div className="info-item-input">
                        <DateInput2 date={holidayDate} setDate={setHolidayDate} isView={false}/>
                        </div>
                    </div>
                    <div className="popUp-item info-item column">
                        <div className="info-item-label">Days</div>
                        <div className="info-item-input">
                        <input
                            type="number"
                            id="hours"
                            placeholder="Days"
                            value={holidayDays}
                            readOnly={true}
                        />
                        </div>
                    </div>
                    </div>
                </>
                }
                <div className="popUp-item info-item column">
                    <div className="info-item-label">Reason</div>
                    <div className="info-item-input">
                    <textarea
                        id="tamper"
                        className="filterSelect"
                        style={{
                        width: "90%",
                        minHeight: "50px",
                        borderRadius: "3px",
                        border: "1px solid #80808080",
                        color: "rgb(104, 104, 104)",
                        }}
                        value={reason}
                        readOnly={true}
                    />
                    </div>
                </div>
                <div className="popUp-item info-item column">
                    <div className="info-item-label">Upload</div>
                    <div className="info-item-input">
                    {files.length > 0 && (
                        <div
                        style={{ border: "1px solid #97979745", padding: "10px" }}
                        >
                        <span>Uploaded File:</span>
                        <ul>
                            {files.map((file, index) => (
                            <img
                                src={file ? URL.createObjectURL(file) : ""}
                                alt=""
                                style={{ width: "150px", height: "auto" }}
                                onClick={() => viewImage({ content: file })}
                            ></img>
                            ))}
                        </ul>
                        </div>
                    )}
                    </div>
                </div>
                </div>
                <div
                className="buttons row"
                style={{ justifyContent: "end", padding: "20px 40px" }}
                >
                <button
                    id="add-family"
                    className="cancel row"
                    onClick={handleClose}
                >
                    Close
                </button>
                </div>
            </div>
            )}
        </div>
        </>
    );
}
function EditOffsetForm({
    isOpen,
    onClose,
    user,
    employeePersonalInformationFullName, setEmployeePersonalInformationFullName,
    employeePersonalInformationId, setEmployeePersonalInformationId,
    references, setReferences,
    date, setDate,
    hours, setHours,
    type, setType,
    dateFrom, setDateFrom,
    dateTo, setDateTo,
    days, setDays,
    holidayDate, setHolidayDate,
    holidayDays, setHolidayDays,
    reason, setReason,
    files, setFiles,
    editData,
    handleUpdate,
    viewImage,
}) {
    const [showReferenceForm, setShowReferenceForm] = useState(false);
    const openReferenceForm = () => {
        setShowReferenceForm(true);
    };
    const closeReferenceForm = () => {
        setShowReferenceForm(false);
    };
    const [showReferenceDateForm, setShowReferenceDateForm] = useState(false);
    const openReferenceDateForm = () => {
        setShowReferenceDateForm(true);
    };
    const closeReferenceDateForm = () => {
        setShowReferenceDateForm(false);
    };

    const handleClose = () => {
        onClose();
        closeReferenceForm()
        closeReferenceDateForm()
    };

    // for upload
    const handleBrowse = (e) => {
        const fileList = Array.from(e.target.files);

        if (fileList.length > 0) {
        if (!fileList[0].type.startsWith("image/")) {
            alert("Please select an image file.");
            setFiles("");
            return;
        }
        }

        setFiles(fileList);
    };
    const handleDrop = (e) => {
        e.preventDefault();

        const fileList = Array.from(e.dataTransfer.files);
        e.currentTarget.style.backgroundColor = "white";

        if (fileList.length > 0) {
        if (!fileList[0].type.startsWith("image/")) {
            alert("Please select an image file.");
            setFiles("");
            return;
        }
        }

        setFiles(fileList);
    };
    const handleDragOver = (e) => {
        e.preventDefault();
        e.currentTarget.style.backgroundColor = "#bdbdbd7d";
    };
    const handleDragOut = (e) => {
        e.preventDefault();
        e.currentTarget.style.backgroundColor = "white";
    };
    const clearFiles = () => {
        // Clear the files state
        setFiles([]);
        // Reset the value of the file input
        document.getElementById("fileInput").value = "";
    };


    const removeReference = (id) => {
        setReferences((prev) => prev.filter((item) => item.id !== id));
    };

    useEffect(() => {
        const totalHours = references.reduce((sum, item) => sum + (item?.hours || 0), 0);
        setHours(totalHours);
    }, [references, setHours]);

    useEffect(() => {
        const totalDays = references.reduce((sum, item) => sum + (item?.days || 0), 0);
        setDays(totalDays);
    }, [references, setDays]);

    const clearReferences = () => {
        setReferences([])
    }

    return (
        <>
        <div className={`modal-overlay ${isOpen ? "open" : ""}`}>
            {isOpen && (
            <div className="modal">
                <div className="popUp-header row">
                <div className="popUp-title">
                    <h3 style={{ color: "#668fca" }}>Update Details</h3>
                </div>
                <div className="popUp-close">
                    <CloseIcon onClick={() => handleClose()} />
                </div>
                </div>
                <div className="popUp-body">
                <div className="popUp-item info-item column">
                    <div className="info-item-label">Employee</div>
                    <div className="info-item-input">
                    <input
                        readOnly={true}
                        id="employeePersonalInformationFullName"
                        placeholder="Employee"
                        value={employeePersonalInformationFullName}
                        onChange={(e) =>
                        setEmployeePersonalInformationFullName(e.target.value)
                        }
                        style={{ cursor: "not-allowed" }}
                    />
                    </div>
                </div>
                <div className="info-item-holder row">
                    <div className="popUp-item info-item column">
                    <div className="info-item-label">Employee Id</div>
                    <div className="info-item-input">
                        <input
                        readOnly={true}
                        type="number"
                        id="employeePersonalInformationId"
                        placeholder="Employee Id"
                        value={employeePersonalInformationId}
                        onChange={(e) =>
                            setEmployeePersonalInformationId(e.target.value)
                        }
                        style={{ cursor: "not-allowed" }}
                        />
                    </div>
                    </div>
                </div>
                <div className="popUp-item info-item column">
                    <div className="info-item-label">Type</div>
                    <div className="info-item-input">
                    <TypeSelect data={type} setData={setType} isView={false} clearReferences={clearReferences}/>
                    </div>
                </div>
                {type === "Overtime" &&
                <>
                <div className="info-item-holder row">
                    <div className="popUp-item info-item column">
                        <div className="info-item-label">References</div>
                        <div className="info-item-input flex flex-col gap-2 justify-center">
                            <button className="add-reference bg-green-500 hover:bg-green-600 hover:cursor-pointer border-none text-white rounded-sm w-[120px]"
                            onClick={()=>openReferenceDateForm()}
                            >Add Reference</button>
                            {references.map((item) => {
                                return (
                                    <div key={item.id} className="flex flex-row gap-5">
                                        <span>{item?.offsetOvertime?.date ? `Date: ${item?.offsetOvertime?.date?.split("T")[0]}` : ""}</span>
                                        <span>{item?.offsetOvertime?.hours ? `Hours: ${item.offsetOvertime?.hours}` : ""}</span>
                                        <button className="bg-red-400 hover:bg-red-500 hover:cursor-pointer border-none text-white rounded-sm"
                                        onClick={()=>removeReference(item.id)}
                                        >remove</button>
                                    </div>
                                );
                            })}
                        </div>
                    </div>
                </div>
                <div className="info-item-holder row">
                    <div className="popUp-item info-item column">
                    <div className="info-item-label">Date (To Use)</div>
                    <div className="info-item-input">
                        <DateInput2 date={date} setDate={setDate} isView={false}/>
                    </div>
                    </div>
                    <div className="popUp-item info-item column">
                    <div className="info-item-label">Hours</div>
                    <div className="info-item-input">
                        <input
                        type="number"
                        id="hours"
                        placeholder="Hours"
                        value={hours}
                        onChange={(e) => setHours(e.target.value)}
                        />
                    </div>
                    </div>
                </div>
                </>}
                {type === "Leave" &&
                <>
                <div className="info-item-holder row">
                    <div className="popUp-item info-item column">
                        <div className="info-item-label">References</div>
                        <div className="info-item-input flex flex-col gap-2 justify-center">
                            <button className="bg-green-500 hover:bg-green-600 hover:cursor-pointer border-none text-white rounded-sm w-[120px]"
                            onClick={()=>openReferenceForm()}
                            >Add Reference</button>
                            {references.map((item) => {
                                return (
                                    <div key={item.id} className="flex flex-row gap-5">
                                        <span>{item?.offsetLeave?.leaveId ? `Reference Number: LV-${item?.offsetLeave?.leaveId?.toString()?.padStart(6, "0")}` : ""}</span>
                                        <span>{item?.offsetLeave?.days ? `Days: ${item?.offsetLeave?.days}` : ""}</span>
                                        <button className="bg-red-400 hover:bg-red-500 hover:cursor-pointer border-none text-white rounded-sm"
                                        onClick={()=>removeReference(item.id)}
                                        >remove</button>
                                    </div>
                                );
                            })}
                        </div>
                    </div>
                </div>
                <div className="info-item-holder row">
                    <div className="popUp-item info-item column">
                    <div className="info-item-label">Days</div>
                    <div className="info-item-input">
                        <input
                        type="number"
                        id="days"
                        placeholder="Days"
                        value={days}
                        onChange={(e) => setDays(e.target.value)}
                        />
                    </div>
                    </div>
                </div>
                <div className="info-item-holder row">
                    <div className="popUp-item info-item column">
                    <div className="info-item-label">Date From (To Use)</div>
                    <div className="info-item-input">
                        <DateInput2 date={dateFrom} setDate={setDateFrom} isView={false} />
                    </div>
                    </div>
                    <div className="popUp-item info-item column">
                    <div className="info-item-label">Date To (To Use)</div>
                    <div className="info-item-input">
                        <DateInput2 date={dateTo} setDate={setDateTo} isView={false} />
                    </div>
                    </div>
                </div>
                </>}
                {type === "Holiday" &&
                <>
                <div className="info-item-holder row">
                    <div className="popUp-item info-item column">
                        <div className="info-item-label">References</div>
                        <div className="info-item-input flex flex-col gap-2 justify-center">
                            <button className="bg-green-500 hover:bg-green-600 hover:cursor-pointer border-none text-white rounded-sm w-[120px]"
                            onClick={()=>openReferenceDateForm()}
                            >Add Reference</button>
                            {references.map((item) => {
                                return (
                                    <div key={item.id} className="flex flex-row gap-5">
                                        <span>{item?.offsetHoliday?.date ? `Date: ${item?.offsetHoliday?.date?.split("T")[0]}` : ""}</span>
                                        <span>{item?.offsetHoliday?.days ? `Hours: ${item.offsetHoliday?.days}` : ""}</span>
                                        <button className="bg-red-400 hover:bg-red-500 hover:cursor-pointer border-none text-white rounded-sm"
                                        onClick={()=>removeReference(item.id)}
                                        >remove</button>
                                    </div>
                                );
                            })}
                        </div>
                    </div>
                </div>
                <div className="info-item-holder row">
                    <div className="popUp-item info-item column">
                    <div className="info-item-label">Date (To Use)</div>
                    <div className="info-item-input">
                        <DateInput2 date={holidayDate} setDate={setHolidayDate} isView={false}/>
                    </div>
                    </div>
                    <div className="popUp-item info-item column">
                    <div className="info-item-label">Days</div>
                    <div className="info-item-input">
                        <input
                        type="number"
                        id="hours"
                        placeholder="Hours"
                        value={holidayDays}
                        onChange={(e) => setHolidayDays(e.target.value)}
                        />
                    </div>
                    </div>
                </div>
                </>}
                <div className="popUp-item info-item column">
                    <div className="info-item-label">Reason</div>
                    <div className="info-item-input">
                    <textarea
                        id="tamper"
                        className="filterSelect"
                        style={{
                        width: "90%",
                        minHeight: "50px",
                        borderRadius: "3px",
                        border: "1px solid #80808080",
                        color: "rgb(104, 104, 104)",
                        }}
                        value={reason}
                        onChange={(e) => setReason(e.target.value)}
                    />
                    </div>
                </div>
                <div className="popUp-item info-item column">
                    <div className="info-item-label">Upload</div>
                    <div className="info-item-input">
                    <label htmlFor="fileInput" className="browse">
                        Browse...
                    </label>
                    <input
                        type="file"
                        id="fileInput"
                        onChange={(e) => handleBrowse(e)}
                        style={{ display: "none" }}
                    />

                    {files.length > 0 ? (
                        <div
                        style={{ border: "1px solid #97979745", padding: "10px" }}
                        >
                        <span>Uploaded File:</span>
                        <ul>
                            {files.map((file, index) => (
                            <img
                                src={
                                file
                                    ? URL.createObjectURL(file)
                                    : "images/sample.jpg"
                                }
                                alt=""
                                style={{ width: "150px", height: "auto" }}
                                onClick={() => viewImage({ content: file })}
                            ></img>
                            ))}
                        </ul>
                        <div
                            className="buttons row"
                            style={{ display: "flex", justifyContent: "end" }}
                        >
                            <button
                            id="add-family"
                            className="cancel row"
                            onClick={() => clearFiles()}
                            style={{ marginRight: "5px" }}
                            >
                            CLEAR
                            </button>
                        </div>
                        </div>
                    ) : (
                        <div
                        id="drop-files-here"
                        onDrop={(e) => handleDrop(e)}
                        onDragOver={(e) => handleDragOver(e)}
                        onDragLeave={(e) => handleDragOut(e)}
                        style={{
                            border: "2px dashed #ccc",
                            borderRadius: "5px",
                            padding: "20px",
                            marginTop: "10px",
                            textAlign: "center",
                        }}
                        >
                        Drop files here
                        </div>
                    )}
                    </div>
                </div>
                </div>
                <div
                className="buttons row"
                style={{ justifyContent: "end", padding: "20px 40px" }}
                >
                <button
                    id="add-family"
                    className="save row"
                    style={{ marginRight: "5px" }}
                    onClick={handleUpdate}
                >
                    Update
                </button>
                <button
                    id="add-family"
                    className="cancel row"
                    onClick={handleClose}
                >
                    Close
                </button>
                </div>
            </div>
            )}
        </div>
        { showReferenceForm &&
        <ReferenceSelectForm
            isOpen={showReferenceForm}
            onClose={closeReferenceForm}
            references={references} setReferences={setReferences}
            editData={editData}
            user={user}
        ></ReferenceSelectForm> }
        { showReferenceDateForm &&
        <ReferenceDateSelectForm
            isOpen={showReferenceDateForm}
            onClose={closeReferenceDateForm}
            references={references} setReferences={setReferences}
            editData={editData}
            user={user}
        ></ReferenceDateSelectForm>}
        </>
    );
}
function CreateTableTransaction({ dataList = [], 
    dataHeader = [], 
    dataAccessor = [], 
    viewHandleClick, 
    editHandleClick,
    deleteHandleClick,
    viewImage,
    approvals, 
    hierarchy, 
    listOfEmployees,
    overtimeRequestData,
    leaveRequestData,
    changeOfScheduleData,
    changeLogRequestData,
    
    currentPage, setCurrentPage
}) {
    const itemsPerPage = 7;

    const columns = React.useMemo(() =>
        dataHeader.map((header, index) => ({
            Header: header,
            accessor: dataAccessor[index]
        })),
        [dataHeader, dataAccessor]
    );

    const [sortHeaderValue, setSortHeaderValue] = useState({ id: "", desc: false, isDefault: true });

    const {
        getTableProps,
        getTableBodyProps,
        headerGroups,
        rows,
        prepareRow,
        setSortBy
    } = useTable(
        {
            columns,
            data: dataList,
            initialState: {
                sortBy: sortHeaderValue.isDefault
                    ? []  // No sorting if it's default
                    : [{ id: sortHeaderValue.id, desc: sortHeaderValue.desc }] // Apply sorting if not default
            }
        },
        useSortBy
    );

    const indexOfFirstItem = (currentPage - 1) * itemsPerPage;
    const indexOfLastItem = Math.min(currentPage * itemsPerPage, rows?.length);
    const currentItems = rows.slice(indexOfFirstItem, indexOfLastItem);

    const totalPages = Math.ceil(rows?.length / itemsPerPage);
    const isLastPage = currentPage === totalPages;

    const paginate = (pageNumber) => {
        if (pageNumber >= 1 && pageNumber <= totalPages) {
            setCurrentPage(pageNumber);
        }
    };

    //Sorting Feature
    const sortState = [
        { id: 0, state: "default", textValue: "" },
        { id: 1, state: "ascending", textValue: "↑" },
        { id: 2, state: "descending", textValue: "↓" }
    ];

    const headerClick = (column) => {
        if (sortHeaderValue.id !== column.id) {
            // New column selected, start with ascending order
            setSortHeaderValue({ id: column.id, desc: false, isDefault: false });
            setSortBy([{ id: column.id, desc: false }]);
        } else {
            // Toggle between sorting states (default -> ascending -> descending -> default)
            if (sortHeaderValue.isDefault) {
                setSortHeaderValue({ id: column.id, desc: false, isDefault: false }); // Ascending
                setSortBy([{ id: column.id, desc: false }]);
            } else if (!sortHeaderValue.desc) {
                setSortHeaderValue({ id: column.id, desc: true, isDefault: false }); // Descending
                setSortBy([{ id: column.id, desc: true }]);
            } else {
                setSortHeaderValue({ id: "", desc: false, isDefault: true }); // Default (no sorting)
                setSortBy([]); // Clear sorting
            }
        }
    };

    // Ensure sorting is reapplied on dataList reload
    useEffect(() => {
        if (!sortHeaderValue.isDefault && sortHeaderValue.id) {
            setSortBy([{ id: sortHeaderValue.id, desc: sortHeaderValue.desc }]);
        }
    }, [dataList, setSortBy, sortHeaderValue]);

    return (
        <div>
            <table {...getTableProps()}>
                <thead>
                    {headerGroups.map((headerGroup) => (
                        <tr {...headerGroup.getHeaderGroupProps()}>
                            {headerGroup.headers.map((column) => (
                                <th
                                    {...column.getHeaderProps()}
                                    onClick={() => headerClick(column)}
                                    className="sortable-header"
                                >
                                    {`${column.render("Header")} ${
                                        sortHeaderValue.id === column.id
                                            ? sortState[sortHeaderValue.isDefault ? 0 : sortHeaderValue.desc ? 2 : 1].textValue
                                            : ""
                                    }`}
                                </th>
                            ))}
                        </tr>
                    ))}
                </thead>
                <tbody {...getTableBodyProps()}>
                    {dataList?.length <= 0 &&
                        <tr>
                            <td colSpan={columns?.length} style={{ textAlign: "center" }}>
                                No data to display
                            </td>
                        </tr>
                    }
                    {currentItems.map((row) => {
                        prepareRow(row)
                        return (
                            <tr key={row.original.id}
                            {...row.getRowProps()}
                            >
                                {row.cells.map((cell) => (
                                    <SetInfoTransaction header={cell.render("Cell").props.column.Header} 
                                        _cell={cell}
                                        viewHandleClick={viewHandleClick}
                                        editHandleClick={editHandleClick}
                                        deleteHandleClick={deleteHandleClick}
                                        viewImage={viewImage}
                                        approvals={approvals}
                                        hierarchy={hierarchy}
                                        listOfEmployees={listOfEmployees}
                                        dataList={dataList}
                                        overtimeRequestData={overtimeRequestData}
                                        leaveRequestData={leaveRequestData}
                                        changeOfScheduleData={changeOfScheduleData}
                                        changeLogRequestData={changeLogRequestData}
                                    />
                                ))}
                            </tr>
                        )
                    })}
                </tbody>
            </table>
            {rows?.length > itemsPerPage ? (
            <div>
                <div className='table-page row' style={{alignItems:"center", justifyContent:"end", padding: "20px 0 0 0"}}>
                    <button className='prev row' onClick={() => paginate(1)} disabled={currentPage === 1}
                            style={{ visibility: (currentPage === 1) ? 'hidden' : 'visible', marginRight:"5px", height:"26px" }}>
                        &lt;&lt;
                    </button>
                    <button className='prev row' onClick={() => paginate(currentPage - 1)} disabled={currentPage === 1}
                            style={{ visibility: (currentPage === 1) ? 'hidden' : 'visible', marginRight:"5px" }}>
                        <NavigateBeforeIcon style={{marginRight:"5px"}}/> PREVIOUS
                    </button>
                    <button className='next row' onClick={() => paginate(currentPage + 1)} disabled={indexOfLastItem >= rows?.length}
                        style={{ visibility: (rows?.length > itemsPerPage && !isLastPage) ? 'visible' : 'hidden', marginRight:"5px" }}>
                        NEXT <NavigateNextIcon style={{ marginLeft: "5px" }} />
                    </button>
                    <button className='next row' onClick={() => paginate(totalPages)} disabled={indexOfLastItem >= rows?.length}
                        style={{ visibility: (rows?.length > itemsPerPage && !isLastPage) ? 'visible' : 'hidden', height:"26px"}}>
                        &gt;&gt;
                    </button>
                </div>
                {`${currentPage}/${totalPages}`}
            </div>
            ) :
            <></>}
        </div>
    )
}
function SetInfoTransaction({header, 
    _cell, 
    viewHandleClick, 
    editHandleClick,
    deleteHandleClick,
    viewImage,
    approvals, 
    hierarchy, 
    listOfEmployees, 
    dataList,
    overtimeRequestData,
    leaveRequestData,
    changeOfScheduleData,
    changeLogRequestData,
}) {
    const data = _cell.render("Cell").props.row.original;
    const value = _cell.render("Cell").props.value;

    if (header === "Photo") {
        if (header === "Photo") {
            if(data.photo){
                const imageSrc = 'data:image/jpeg;base64,' + data.photo;
    
                return(
                    <td>
                        <img className="avatarImg" src={imageSrc} alt=""/>
                    </td>
                )
            }
            return(
                <td>
                    <img className="avatarImg" src="images/sample.jpg" alt=""/>
                </td>
            )
        }
        
        if(value === "" || value === null || value === undefined){
            return(
                <td>
                    <img className="avatarImg" src="images/sample.jpg" alt=""/>
                </td>
            )
        } else {
            return(
                <td>
                    <img className="avatarImg" src="images/sample.jpg" alt=""/>
                </td>
            )
        }
    }

    if (header === "Track Approvers") {
        const trackApproval = data.approval;
        
        if(!trackApproval){
            return(
                <td>
                    <>
                        {`Primary Approver: Pending`}
                        <br />
                        <br />
                        {`Secondary Approver: Pending`}
                        <br />
                        <br />
                        {`Tertiary Approver: Pending`}
                        <br />
                        <br />
                    </>
                </td>
            )
        }

        return(
            <td>
                    <>

                        { trackApproval.primaryApproverId !== undefined &&
                            <>
                                <span>{`Primary Approver: `}</span>
                                <span style={{padding: "1px 5px"}} className={trackApproval.primaryApproverStatus}>{`${trackApproval.primaryApproverStatus !== "" ? trackApproval.primaryApproverStatus : "Pending"}`}</span>
                                { (trackApproval.primaryApproverStatus === "Approved" || trackApproval.primaryApproverStatus === "Disapproved") &&
                                trackApproval.primaryApproverFullName &&
                                    <span style={{padding: "1px 5px"}}>{`- ${trackApproval.primaryApproverFullName}`}</span>
                                }
                                <br />
                                <br />
                            </>
                        }
                        { trackApproval.secondaryApproverId !== undefined &&
                            <>
                                <span>{`Secondary Approver: `}</span>
                                <span style={{padding: "1px 5px"}} className={trackApproval.secondaryApproverStatus}>{`${trackApproval.secondaryApproverStatus !== "" ? trackApproval.secondaryApproverStatus : "Pending"}`}</span>
                                { (trackApproval.secondaryApproverStatus === "Approved" || trackApproval.secondaryApproverStatus === "Disapproved") &&
                                trackApproval.secondaryApproverFullName &&
                                    <span style={{padding: "1px 5px"}}>{`- ${trackApproval.secondaryApproverFullName}`}</span>
                                }
                                <br />
                                <br />
                            </>
                        }
                        { trackApproval.tertiaryApproverId !== undefined &&
                            <>
                                <span>{`Tertiary Approver: `}</span>
                                <span style={{padding: "1px 5px"}} className={trackApproval.tertiaryApproverStatus}>{`${trackApproval.tertiaryApproverStatus !== "" ? trackApproval.tertiaryApproverStatus : "Pending"}`}</span>
                                { (trackApproval.tertiaryApproverStatus === "Approved" || trackApproval.tertiaryApproverStatus === "Disapproved") &&
                                trackApproval.tertiaryApproverFullName &&
                                    <span style={{padding: "1px 5px"}}>{`- ${trackApproval.tertiaryApproverFullName}`}</span>
                                }
                                <br />
                                <br />
                            </>
                        }
                    </>
            </td>
        )
    }

    if(header === "Uploaded Image"){
        if(data.requestTypeId === 1){ //Leave
            if(leaveRequestData?.length <= 0){ return(<td></td>) }
            const foundData = leaveRequestData.find(_data => _data.id === data.id)
            if(foundData.content){
                return(
                    <td>
                        <div className="emp-transac-manage row"  style={{alignItems:"center", justifyContent:"center"}}>
                            <TooltipManage text="View Image">
                                <div style={{padding:"0 5px"}} onClick={()=>viewImage(foundData)}><ImageIcon/></div>
                            </TooltipManage>
                        </div>
                    </td>
                )
            }
            return(
                <td>
                </td>
            )
        } else if(data.requestTypeId === 2){ //Change Schedule
            if(changeOfScheduleData?.length <= 0){ return(<td></td>) }
            const foundData = changeOfScheduleData.find(_data => _data.id === data.id)
            if(foundData.content){
                return(
                    <td>
                        <div className="emp-transac-manage row"  style={{alignItems:"center", justifyContent:"center"}}>
                            <TooltipManage text="View Image">
                                <div style={{padding:"0 5px"}} onClick={()=>viewImage(foundData)}><ImageIcon/></div>
                            </TooltipManage>
                        </div>
                    </td>
                )
            }
            return(
                <td>
                </td>
            )
        } else if(data.requestTypeId === 3){ //OT
            if(overtimeRequestData?.length <= 0){ return(<td></td>) }
            const foundData = overtimeRequestData.find(_data => _data.id === data.id)
            if(foundData.content){
                return(
                    <td>
                        <div className="emp-transac-manage row"  style={{alignItems:"center", justifyContent:"center"}}>
                            <TooltipManage text="View Image">
                                <div style={{padding:"0 5px"}} onClick={()=>viewImage(foundData)}><ImageIcon/></div>
                            </TooltipManage>
                        </div>
                    </td>
                )
            }
            return(
                <td>
                </td>
            )
        } else if(data.requestTypeId === 4){ // Change Log
            if(changeLogRequestData?.length <= 0){ return(<td></td>) }
            const foundData = changeLogRequestData.find(_data => _data.id === data.id)
            if(foundData.content){
                return(
                    <td>
                        <div className="emp-transac-manage row"  style={{alignItems:"center", justifyContent:"center"}}>
                            <TooltipManage text="View Image">
                                <div style={{padding:"0 5px"}} onClick={()=>viewImage(foundData)}><ImageIcon/></div>
                            </TooltipManage>
                        </div>
                    </td>
                )
            }
            return(
                <td>
                </td>
            )
        }
    }

    if(header === "Reference No."){
        const formattedNumber = value.toString().padStart(6, '0');

        if(data.requestTypeId === 1){
            return (
                <td>
                    LV-{formattedNumber}
                </td>
            );
        } else if(data.requestTypeId === 2){
            return (
                <td>
                    CS-{formattedNumber}
                </td>
            );
        } else if(data.requestTypeId === 3){
            return (
                <td>
                    OT-{formattedNumber}
                </td>
            );
        } else if(data.requestTypeId === 4){
            return (
                <td>
                    CH-{formattedNumber}
                </td>
            );
        }  else if(data.requestTypeId === 5){
            return (
                <td>
                    OS-{formattedNumber}
                </td>
            );
        }   else if(data.requestTypeId === 6){
            return (
                <td>
                    OB-{formattedNumber}
                </td>
            );
        } 
    }

    if(header === "Type"){
        const foundData = dataList.find(dataInfo => (dataInfo.requestTypeId === data.requestTypeId) && (dataInfo.id === data.id)) 

        if(foundData.requestTypeId === 1) { // Leave
            if(leaveRequestData?.length <= 0){ return(<td></td>) }
            const foundDataLeave = leaveRequestData.find(request => request.id === foundData.id);
            return (
                <td>
                    {foundDataLeave.leaveTypeDescription}
                </td>
            );
        } else if(foundData.requestTypeId === 2) { // Change Schedule
            return (
                <td>
                    {"-"}
                </td>
            );
        } else if(foundData.requestTypeId === 3) { // OT
            if(overtimeRequestData?.length <= 0){ return(<td></td>) }
            const foundDataOT = overtimeRequestData.find(request => request.id === foundData.id);
            return (
                <td>
                    {foundDataOT.overtimeType}
                </td>
            );
        } else if(foundData.requestTypeId === 4) { // Change Log
            if(changeLogRequestData?.length <= 0){ return(<td></td>) }
            const foundDataChangeLog = changeLogRequestData.find(request => request.id === foundData.id);
            return (
                <td>
                    {`Time - ${foundDataChangeLog.timeType}`}
                </td>
            );
        }
    }

    if (header === "Status") {
        let convertedValue = value;

        if(convertedValue === "Sent"){
            convertedValue = "Pending";
        }
        return(
            <td className={convertedValue}>
                {convertedValue}
            </td>
        )
    }

    if( header === "Time In"
    || header === "Time Out"
    || header === "Time Rendered"
    ){
        const time = _cell.render("Cell").props.value;

        if (!time) {
            return (
                <td>
                    -
                </td>
            );
        }
    
        let formattedTime = '';
    
        // Attempt to parse the time if it’s not already in ISO format
        let date;
        if (time.includes('T')) {
            date = new Date(time);
        } else {
            // If the time is not in ISO format, manually create the date
            const currentDate = new Date(); // Get current date for the date portion
            const [hours, minutes] = time.split(':').map(part => parseInt(part, 10));
    
            if (isNaN(hours) || isNaN(minutes)) {
                return (
                    <td>
                        Invalid time format
                    </td>
                );
            }
    
            date = new Date(currentDate.getFullYear(), currentDate.getMonth(), currentDate.getDate(), hours, minutes);
        }
    
        if (isNaN(date.getTime())) {
            return (
                <td>
                    Invalid time format
                </td>
            );
        }
    
        // Convert to desired format YYYY-MM-DDTHH:mm
        // const year = date.getFullYear();
        // const month = String(date.getMonth() + 1).padStart(2, '0'); // Months are 0-indexed
        // const day = String(date.getDate()).padStart(2, '0');
        const hours = String(date.getHours()).padStart(2, '0');
        const minutes = String(date.getMinutes()).padStart(2, '0');
    
        // const formattedDateTime = `${year}-${month}-${day}T${hours}:${minutes}`;
    
        // console.log(formattedDateTime); // Logs the converted time for debugging
    
        // Further formatting based on globalTimeFormat
        if (globalTimeFormat === "Standard Time") {
            const amPm = date.getHours() >= 12 ? 'PM' : 'AM';
            const standardHours = (date.getHours() % 12) || 12; // Convert 0 to 12 for 12-hour format
    
            formattedTime = `${standardHours}:${minutes} ${amPm}`;
        } else if (globalTimeFormat === "Military Time") {
            formattedTime = `${hours}:${minutes}`;
        }
    
        return (
            <td>
                {formattedTime}
            </td>
        );
    }

    if(header === "Date"
    || header === "Date From"
    || header === "Date To"
    || header === "Date Processed"
    || header === "Request Date"
    || header === "Date Requested"
    || header === "Reference Date"
    || header === "Date To Use"
    ){
        const date = new Date(_cell.render("Cell").props.value);
        if(!date) {
            return (
                <td>
                    -
                </td>
            );
        }

        const mm = date.getMonth() + 1; // Adding 1 because getMonth returns 0-indexed months
        const dd = date.getDate();
        const yyyy = date.getFullYear();

        const formattedDateFrom = `${mm}/${dd}/${yyyy}`;
        
        return(
            <td>
                {formattedDateFrom}
            </td>
        )
    }

    if (header === "") {
        return(
            <td>
                <div className="emp-transac-manage row"  style={{alignItems:"center", justifyContent:"center"}}>
                    <TooltipManage text="Update">
                        <div style={{padding:"0 5px"}} onClick={()=>editHandleClick(data)}><EditIcon/></div>
                    </TooltipManage>
                    <TooltipManage text="Cancel">
                        <div style={{padding:"0 5px"}} onClick={()=>deleteHandleClick(data)}><NotInterestedIcon/></div>
                    </TooltipManage>
                    <TooltipManage text="View">
                        <div style={{padding:"0 5px"}} onClick={()=>viewHandleClick(data)}><RemoveRedEyeIcon/></div>
                    </TooltipManage>
                </div>
            </td>
        )
    }

    return (
        <td {..._cell.getCellProps()}> {_cell.render("Cell")}</td>
    )
}
const TooltipManage = ({ text, children }) => {
    const [show, setShow] = useState(false);

    const handleMouseEnter = () => {
        setShow(true);
    };

    const handleMouseLeave = () => {
        setShow(false);
    };

    return (
        <div style={{ position: 'relative', display: 'inline-block',zIndex:"1" }}>
            <div onMouseEnter={handleMouseEnter} onMouseLeave={handleMouseLeave}>
            {children}
            </div>
            {show && (
            <div
                style={{
                position: 'absolute',
                top: '50%',
                left: '-50%',
                transform: 'translateX(-50%)',
                backgroundColor: 'white',
                color: 'gray',
                padding: '5px',
                borderRadius: '5px',
                pointerEvents: "none",
                boxShadow: "0 4px 8px 0 rgba(0, 0, 0, 0.2), 0 6px 20px 0 rgba(0, 0, 0, 0.19)"
                }}
            >
                {text}
            </div>
            )}
        </div>
    );
};
function ClearGeneralForm({isOpen, 
    onClose, 
    handleDelete}
){
    const handleClose = () => {
        onClose();
    };

    return (
        <>
            <div className={`modal-overlay ${isOpen ? 'open' : ''}`}>
                {isOpen && (
                <div className="modal">
                    <div className="popUp-header row">
                        <div className="popUp-title">
                            <h3 style={{ color: "#668fca" }}>Cancel!</h3>
                        </div>
                        <div className="popUp-close">
                            <CloseIcon onClick={()=>handleClose()} />
                        </div>
                    </div>
                    <div className="popUp-body" style={{display:"flex", alignItems:"center", justifyContent:"center"}}>
                        <span>Are you sure you want to cancel this request?</span>
                    </div>
                    <div className="buttons row" style={{justifyContent:"center", padding:"40px 40px 20px 40px"}}>
                        <button id="add-family" 
                            className="save row"
                            onClick={(e)=>{handleDelete(e); handleClose()}}
                            style={{marginRight:"5px"}}>
                                YES
                        </button>
                        <button id="add-family" 
                            className="cancel row"
                            onClick={()=>handleClose()}>
                                NO
                        </button>
                    </div>
                </div>
            )}
            </div>
        </>
    );
}
function ViewImage({isOpen, 
    onClose,
    viewImageData
})
{
    const [imageSource, setImageSource] = useState("");

    const handleClose = () => {
        onClose();
    };

    useEffect(() => {
        if (isOpen && viewImageData.content instanceof File) {
            const reader = new FileReader();
            
            reader.onloadend = () => {
                // Once the file is read, set the image source to the base64 data
                setImageSource(reader.result);
            };
    
            // Read the file as a Data URL (which includes the base64 encoding)
            reader.readAsDataURL(viewImageData.content);
        }
    }, [isOpen, viewImageData]);

    const [isImageModalOpen, setIsImageModalOpen] = useState(false);
    const openImage = () => {
        setIsImageModalOpen(true); // Open image in full view
    };
    
    const closeImageModal = () => {
        setIsImageModalOpen(false); // Close full image modal
    };

    return (
        <>
            <div className={`modal-overlay ${isOpen ? 'open' : ''}`}>
                {isOpen && (
                <div className="modal">
                    <div className="popUp-header row">
                        <div className="popUp-title">
                            <h3 style={{ color: "#668fca" }}>Uploaded Image</h3>
                        </div>
                        <div className="popUp-close">
                            <CloseIcon onClick={()=>handleClose()} />
                        </div>
                    </div>
                    <div className="popUp-body">
                        <div style={{display:"flex", alignItems:"center", justifyContent:"center"}}>
                            <img className="modal-events-image" src={imageSource} alt="" style={{width: "250px", height: "auto"}} onClick={openImage}/>
                        </div>
                    </div>
                    <div className="buttons row" style={{justifyContent:"end", padding:"20px 40px"}}>
                        <button id="add-family" 
                            className="cancel row"
                            style={{height: "34px", borderRadius: "3px"}}
                            onClick={handleClose}>
                                Close
                        </button>
                    </div>
                </div>
            )}
            </div>

            {/* Full Image Modal */}
            {isImageModalOpen && (
                <div
                    style={{
                        position: "fixed",
                        top: 0,
                        left: 0,
                        width: "100%",
                        height: "100%",
                        backgroundColor: "rgba(0, 0, 0, 0.8)",
                        display: "flex",
                        justifyContent: "center",
                        alignItems: "center",
                        zIndex: 9999
                    }}
                    onClick={closeImageModal} // Click outside to close
                >
                    <img
                        src={imageSource}
                        alt="Full view"
                        style={{ maxWidth: "90%", maxHeight: "90%" }}
                    />
                </div>
            )}
        </>
    );
}
function DateInput2({date, setDate, isView}) {
    const [isSelected, setIsSelected] = useState(false);

    const handleDateTimeChange = (event) => {
        setDate(event.target.value);
        setIsSelected(true);
    };

    useEffect(() => {
        if(date !== undefined && date !== ""){
            setIsSelected(true);
        } else {
            setIsSelected(false);
        }
    }, [date]);

    let formattedDate = "";

    if(date){
        formattedDate = date.split('T')[0];
    }

    return (
        <div>
            <input
            readOnly={isView}
            type="date"
            id={"datetime-"}
            name="datetime"
            value={formattedDate} // Exclude milliseconds
            onChange={handleDateTimeChange}
            style={{width:"90%",
                height:"30px", 
                borderRadius:"3px", 
                border:"1px solid #80808080",
                color: isSelected ? "rgb(104, 104, 104)" : "rgba(0, 0, 0, 0.356)",
                fontFamily: "'Trebuchet MS', 'Lucida Sans Unicode', 'Lucida Grande', 'Lucida Sans', Arial, sans-serif"
            }}
            />
        </div>
    );
}
export default OffsetRequest;
